export default {
  actions: {
    creating: 'Creating {{model}}...',
    created_successfully: '{{model}} created successfully',
    creating_error: 'Failed to create {{model_one}}',
    updating: 'Updating {{model}}...',
    updated_successfully: '{{model}} updated successfully',
    updating_error: 'Failed to update {{model_one}}',
    deleting: 'Deleting {{model}}...',
    deleted_successfully: '{{model}} deleted successfully',
    deleting_error: 'Failed to delete {{model_one}}',
    converting: 'Converting {{model_one}} into {{model_two}}...',
    converting_error: 'Failed to convert {{model_one}} into {{model_two}}',
    converted_successfully: '{{model_one}} converted into {{model_two}} successfully',
    exporting: 'Exporting {{model}}...',
    exporting_error: 'Failed to export {{model}}',
    exported_successfully: '{{model}} exported successfully'
  },
  checkbox_jumbotron: {
    model: '{{model}}',
    number: '{{number}}',
    select_advanced: 'Select advanced',
    select_all: 'Select the {{number}} {{model}}.'
  },
  bulk_actions: {
    select_indicator_one: '<1>{{selected}}</1> {{model}} from <1>{{available}}</1> available',
    select_indicator_other: '<1>{{selected}}</1> {{model}} from <1>{{available}}</1> availables'
  },
  datetime: {
    abbr_month_names: ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    distance_in_words: {
      x_periods: {
        one: '1 period',
        other: '{{count}} periods'
      }
    },
    format: {
      dashes: 'YYYY-MM-DD',
      date_box_server: 'DD MMM HH:mm',
      date_issues: 'DD MMM',
      date_discounts: 'DD MMM YYYY',
      date_notifications: 'D MMM YYYY',
      date_olt_card_created: 'DD MMM YYYY',
      date_olt_card_updated: 'DD MMM YYYY HH:mm',
      dateTime: 'DD MMMM YYYY',
      dateTimeLong: 'DD/MM/YYYY hh:mm:ss',
      dateTimeShort: 'DD MMM YYYY HH:mm',
      short: 'DD MMM HH:mm',
      slash: 'YYYY/MM/DD HH:mm:ss',
      slashWithoutSeconds: 'YYYY/MM/DD HH:mm',
      slashWithoutTime: 'YYYY/MM/DD',
      time: 'HH:mm:ss',
      weekDayName: 'dddd DD MMMM YYYY',
      yearMonth: 'YYYY/MM'
    },
    month_name: [
      '',
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ],
    second: {
      abr: 'Sec'
    }
  },
  dual_list: {
    empty_list: 'Empty list',
    filtering: 'Filtering',
    from: 'from',
    show_all: 'Show all',
    showing_all: 'Showing all'
  },
  metrics: {
    client: {
      created: 'Created',
      destroyed: 'Destroyed'
    },
    contract: {
      created: 'Created',
      destroyed: 'Destroyed',
      offline: 'Offline',
      online: 'Online'
    },
    installation_order: {
      approved: 'Approved',
      created: 'Created',
      rejected: 'Rejected'
    },
    invoicing: {
      issued: {
        issued: 'Issued',
        paid: 'Paid'
      },
      payment: {
        count: 'Quantity'
      }
    },
    help_desk: {
      issues: {
        closed: 'Closed',
        created_current_month: 'Created',
        finalized_assigned: 'Finalized assigned',
        finalized_unassigned: 'Finalized unassigned',
        high: 'High',
        low: 'Low',
        medium: 'Medium',
        pending: 'Pending',
        pending_assigned: 'Pending assigned',
        pending_unassigned: 'Pending unassigned',
        still_open: 'Open'
      }
    }
  },
  modal: {
    close: 'Close',
    create: 'Create new {{model}}'
  },
  timeline: {
    version: {
      by: 'By',
      create: 'This Operation was Created',
      destroy: 'This Operation was Deleted',
      update: 'This Operation was Updated '
    }
  },
  filter: {
    badge_content: {
      filter_configuration: 'Filter configuration',
      filter_searched: 'Your search parameters are:',
      hint: ' Rename your search and save it',
      text_searched_title: 'The text you searched for was:',
      validation_message: 'Please type at least 3 characters'
    }
  },
  views: {
    acs_server: {
      create_new_acs_server: 'Create new ACS Server'
    },
    authorized_not_linked_onts: {
      authorized_onts: 'Authorized ONUs',
      breadcrumb: {
        title: 'authorized without contract'
      },
      error_querying_olt: 'Error querying OLT',
      initial: 'Initial',
      link_ont_form: {
        contract_input_placeholder: 'Search by client name, ip or server'
      },
      linked_olts: 'Linked OLTs',
      linked_onts: 'Authorized ONUs with contract',
      match: 'Match',
      must_complete_contract_configuration: 'Must complete the contract configuration',
      must_select_a_contract: 'Must select a contract',
      no_records: 'There are no authorized not linked ONUs to show',
      no_records_linked_olts: 'There are no linked OLTs to show',
      not_linked_onts: 'Authorized ONUs without contract',
      not_authorized_onts: 'Not authorized ONUs',
      offline: 'Offline',
      olt_alerts: 'OLT Alerts',
      olt_interfaces: 'OLT Interfaces',
      olts_queried: 'OLTs queried',
      online: 'Online',
      querying_olt: 'Querying OLT',
      querying_olts: 'Querying OLTs',
      retry_olts_with_errors: 'Retry OLTs with errors',
      successfull_olt_query: 'Successfull OLT query',
      utilization: 'Utilization',
      utilization_tooltip_text: 'Percentage of linked ONUs over the total of ONUs'
    },
    audit: {
      no_audits: 'There are not audits to show',
      changes_done: 'Changes done',
      searcher: {
        basic_placeholder: 'You can search by: Object'
      }
    },
    automigrator: {
      attributes: {
        invoicing: {
          client: {
            kind_invoice: {
              argentina_a: 'Argentine (A)',
              argentina_b: 'Argentine (B)',
              argentina_c: 'Argentine (C)',
              colombia: 'Sales invoice',
              credit_note: 'Credit note',
              ecuador: 'Sales invoice',
              espana: 'Spain',
              invoice: 'Invoice',
              mexico: 'Sales invoice',
              peru_final_consumer_invoice: 'Sales final consumer invoice',
              peru_invoice: 'Sales invoice',
              sales_invoice: 'Sales invoice',
              sales_receipt: 'Sales receipt',
              voucher: 'Voucher'
            }
          }
        }
      },
      client: {
        base: 'Client',
        custom_id: 'Client Custom ID',
        sequential_id: 'Client ID (#)'
      },
      collector: {
        base: 'Collector'
      },
      contract: {
        olt_id: 'OLT',
        coverage_id: 'Wireless Node',
        base: 'Contract',
        invoicing_contract: {
          plan: 'Invoicing Contract Plan'
        },
        identifiers: {
          sequential_id: 'Sequential ID (#)'
        }
      },
      employee: {
        user: {
          role_ids: 'Roles'
        }
      },
      hint: 'We accept {{files}} files.',
      invoice: {
        base: 'Invoice'
      },
      invoicing: {
        client: {
          invoicing_firm_id: 'Invoicing Firm',
          tax_id: 'Tax'
        }
      },
      info: 'You can load any .csv, .xls, .xlsx, .xml, .txt file with any set of columns as long as it has 1 record per row. The next step will allow you to set up and match the columns in your spreadsheet to the corresponding data points. You will be able to delete or remove all corrupted data before finalizing your report.',
      labels: {
        ['client.gps_point']: 'Gps point (Client)',
        ['contract.identifiers']: 'Contract identifiers',
        ['contract.gps_point']: 'Gps point (Contract)',
        invoicing: {
          client: 'Invoicing Client',
          contract: 'Invoicing Contract',
          plan: 'Invoicing Plan'
        },
        ['nap.gps_point']: 'Gps point',
        required: 'Required'
      },
      nap: {
        inventory_article_id: 'Article',
        olt_id: 'OLT'
      },
      payment: {
        base: 'Payment',
        payment_amount: 'Payment amount',
        collector_email: 'Collector email',
        transaction_kind_id: 'Transaction kind'
      },
      plan: {
        name: 'Plan name'
      },
      ppp_profile: {
        plan_id: 'Plan'
      },
      select_file: 'Select file',
      title: 'Import from CSV/Excel file',
      transaction_kind: {
        base: 'Transaction kind'
      },
      types: {
        clients: 'Clients | Create',
        clients_update: 'Clients | Update',
        contracts: 'Contracts',
        employees: 'Employees',
        servers: 'Servers and OLTs',
        smart_olt_olt: 'SmartOLT (OLTs)',
        smart_olt_ont: 'SmartOLT (ONUs)',
        onts_masive_link: 'Masive onus link',
        contracts_onu: 'SmartOLT (ONUs)',
        ppp_profiles: 'PPP Profiles',
        naps: 'Naps'
      },
      upload_file: 'Upload file'
    },
    changelog: {
      add_item: 'Add Item',
      changelog_updated: 'Changelogs Updated',
      changelog_created: 'Changelogs Created',
      changelog_destroyed: 'Changelogs Destroyed'
    },
    contracts: {
      contract_data: 'Datos de Contratos',
      billing_data: 'Billing data'
    },
    bandwidths: {
      by_period: {
        one_day: 'Last day of consumption',
        one_hour: 'Last hour of consumption',
        one_month: 'Last month of consumption',
        one_week: 'Last week of consumption',
        one_year: 'Last year of consumption',
        six_months: 'Last 6 months of consumption',
        three_months: 'Last 3 months of consumption'
      },
      summary: 'Consumption summary'
    },
    client: {
      autocomplete_gps_point_with_google_maps: 'Autocomplete GPS point with Google Maps',
      automatic_debit: 'Automatic debit',
      base_invoiced_date: 'From',
      bulk_actions_successful: 'You will recive an email with the results',
      client_summary: 'Client summary',
      clients_imported_successfully: 'Clients imported successfully',
      clients_portal: 'Clients Portal',
      clients_portal_subtitle: 'This field will be used to access the Clients Portal',
      clients_selected: 'Clients Selected',
      contact_email: 'E-mail contact',
      cpg_can_be_configured: 'The payment gateway can be configured<br />Click here to configure',
      cpg_has_error: 'The payment gateway has an error',
      create_payment_promises:
        '* If the invoice is still unpaid, the contract status will change automatically the following day.',
      customer_barcode: 'Customer barcode',
      deleted_client: 'Inactive client',
      device: {
        copy_login_link: 'Copy login link'
      },
      edit_client: 'Edit client',
      errors_found_review_file: 'Errors found in the file, please check the entered data',
      enter_international_phone_number: 'Enter the number in international format',
      format_international: '+[country code][area code][mobile code][number]',
      export_clients_login_mobile: 'Export Clients (with mobile login link and QR)',
      export_clients_to_prisma: 'Export Clients to Prisma',
      export_error: 'Error in export.',
      export_no_clients_filtered: 'No filtered clients.',
      exporting: 'Exporting...',
      generate_barcode_per_invoice: 'Generate barcode per invoice',
      generate_open_barcode: 'Generate open barcode',
      hints: {
        add_taxes_to_client: 'By checking any of this options, the corresponding tax will be created for the clients',
        authorize_invoice_after_paid:
          'The invoice will be reported to the collecting agency after it has been issued and paid. At the time of issuing the invoice, the invoice will be sent as a voucher. Once reported after payment the invoice will be sent.',
        automatic_state: 'The status of all contracts can be changed by the system automatically.',
        create_payment_promises:
          '* If the invoice is still unpaid, the contract status will change automatically the following day.',
        enable_invoice_to_edit_taxes: 'Enable invoicing to edit taxes',
        invoicing_firm:
          'ISP"s invoicing firm (used to issue invoices). Invoicing firms can be created on [Invoicing] -> [Invoicing firm]',
        national_identification_number:
          'Depending on the country: identification document or identity card or unique registration key.',
        remove_taxes_from_client:
          'By checking any of this options, the correspnoding tax will be removed from the clients',
        send_email_when_create_payment:
          'Each time a payment is created, a receipt will be sent to the customer if he/she has a valid email address.',
        start_invoicing_day:
          'Changing the billing date will affect all contracts and will take effect from the next billing period.',
        switch_issue_invoice:
          "Every time an invoice is issued, it will be sent to the customer's e-mail if he/she has a valid e-mail address.",
        unverified_phone_number: 'Télefono no verificado',
        vat_condition: "Client's iva condition (Receiver)",
        verified_phone_number: 'Télefono verificado'
      },
      import_clients: 'Import Clients',
      import_mobile_phones: 'Import Mobile Phones',
      import_clients_count_one: '{{count}} client will be updated. Are you sure?',
      import_clients_count_other: '{{count}} clients will be updated. Are you sure?',
      invoice_preview: 'Invoice preview',
      //Se quitan despues de la ultima revisión
      invoicing_client: {
        emails_to_notify: 'Emails separated by commas, without spaces.'
      },
      invoicing_client_attributes: {
        emails_to_notify: 'Emails separated by commas, without spaces.',
        has_debt: 'Has debt',
        invoicing_disabled: 'Invoicing disabled',
        payment_gateways: {
          cobroDigital: {
            how_vinculate: 'How to link to the client with CobroDigital?',
            if_the_customer_has_records:
              'If the customer <1>NO</1> has records in CobroDigital, leave the fields blank and the system will automatically generate them once the first invoice is issued.',
            if_the_customer_is_already:
              "If the customer <1>IS ALREADY</1> registered in CobroDigital, enter the customer's ID (e.g. column name: Id, Customer ID, sap_identifier). As well as you can optionally enter the Barcode and PagoMisCuentas if you have them."
          },
          create: 'Create Payment Gateway',
          cuenta_digital: {
            custom_code:
              '<0>Custom code</0>: if you want to customize the barcode and link payment code, enter it in the corresponding fields.',
            generate_coupon_for_each_invoice:
              '<0>Generate coupon per invoice</0>: if you want to generate a coupon per invoice, leave the fields blank or click on <2>Generate coupon per invoice</2>.',
            single_coupon_generation:
              '<0>Unique coupon generation</0>: It will generate a single barcode for the customer to be used in all invoices. Click on <2>Generate unique coupon</2>.'
          },
          issue_disabled: 'issue disabled',
          issue_enabled: 'issue enabled',
          siro: {
            //FIXME
            enter_inputs:
              'If the customer already has a barcode and linkpagos code, enter them in the corresponding fields.',
            generate_for_each_invoice:
              '<0>Generation for each invoice: </0>It will generate a code for each invoice that will expire according to its due date. Click on <2>Generate barcode per invoice.</2>',
            generate_per_customer:
              '<0>Generation per customer: </0>Will generate a unique barcode for the customer and will be used on all invoices. Click on<2> Generate open barcode.</2>'
          }
        },
        positive_balance: 'Positive balance',
        without_debt: 'No debt'
      },
      issue_invoices_in_pg: 'Issue invoices in payment gateway',
      label: {
        authorize_invoice_after_paid: 'Inform after paid',
        send_email_when_create_payment: 'Send email when create payment',
        send_email_when_issue_invoices: 'Send email when issue invoice',
        start_invoicing_day: 'Billing cycle starts on the day',
        switch_issue_invoice: 'Send email when issue invoice'
      },
      last_day_consumption: 'Last day of consumption',
      limit_invoiced_date: 'To',
      location: 'Location',
      mark_payments_and_credit_notes: 'Mark payments and associates credit notes',
      massive_update: {
        add_all_pgs_options: 'Add all payment gateways options',
        add_all_taxes_options: 'Add all tax options',
        authorize_invoice_after_paid: 'Inform after paid',
        automatic_state: 'Automátic state',
        emails_to_notify: 'Emails to notify',
        invoicing_enabled: 'Invoicing',
        invoicing_firm_id: 'Invoicing firm',
        kind_invoice: 'Kind invoice',
        massive_update: 'Massive update',
        payment_method: 'Payment method',
        remove_all_pgs_options: 'Remove all payment gateways options',
        remove_all_taxes_options: 'Remove all tax options',
        send_email_when_create_payment: 'Send email when create payment',
        send_email_when_issue_invoices: 'Send email when issue invoice',
        start_invoicing_day: 'Billing cycle starts on the day'
      },
      massive_update_client_with_errors: '{{error_count}} affected Client',
      massive_update_clients_with_errors: '{{error_count}} affected Clients',
      massive_update_error_detail_message: '{{attr}}: {{error_type}}, {{error_count}}',
      massive_update_error_hint: 'Click on item in the list and filter on table the Clients with errors',
      massive_update_error_loader_message: 'Retrieving error list',
      massive_update_error_refresh: 'No errors have been found in the massive update.',
      massive_update_error_title: 'Massive Update Errors ({{count}} {{plurality}})',
      massive_update_process: 'The massive update is in process.',
      massive_update_remove_all_errors: 'Errors in the massive update have been cleaned up.',
      massively_remove: 'Massively remove',
      new_client: 'New client',
      next_periodic_invoice_link: 'Next invoice for {{amount}} - Period {{period}} - Contract #{{sequential_id}}',
      next_periodic_invoice_title: 'Next Invoice',
      no_contact_information: 'No contact information',
      no_payment_gateways: 'There are no Payment gateways to show',
      number_client: 'N° client',
      one_day: 'Last day of consumption',
      one_hour: 'Last hour of consumption',
      one_month: 'Last month of consumption',
      one_week: 'Last week of consumption',
      one_year: 'Last year of consumption',
      payments_and_associated_credit_notes: 'Payments and associated credit notes',
      process_clients: 'Process Clients',
      removeAllOptions: 'Remove all options',
      update_from_file: 'Update from file',
      searcher_pg_info:
        'Select an option from the list. After selecting it, you can choose whether to include or exclude the item from the search. This will allow you to perform combined searches, where you can specify items to include and items to exclude.',
      see_next_invoices: 'See next invoices',
      show_client_detail: 'See customer details',
      showAllOptions: 'Show all options',
      successful_massive_update: 'Client/s updated',
      the_client_does_not_have_billing_enabled: 'The client does not have billing enabled',
      verified_existence: 'Verified the existence'
    },
    contract: {
      tour: {
        quick_search_description:
          'Instantly filter your contracts, forget about endless scrolling. This new quick search makes your daily queries ultra-fast.',
        advanced_search_description:
          'Create complex queries in seconds with our enhanced filter panel. Combine multiple fields and operators to find exactly what you need.',
        select_all_description:
          'With a single click, select all records for bulk operations. You can also select specific contracts',
        bulk_action_update_description:
          'Apply updates on tens (or hundreds) of contracts simultaneously. Our revamped bulk update tool saves you hours of manual edits.',
        bulk_action_download_description:
          'Download your selected data all at once. Enhanced batch download puts all your records at your fingertips.',
        hero_description: 'View information about the status of the ONUs linked to Contracts'
      },

      bulk_actions: {
        download: {
          hint_1:
            ' Export may take several minutes; to avoid timeouts, download in batches of maximum 1,000 contracts.',
          hint_2: 'Filter your contracts before exporting to reduce file size and complexity.',
          hint_3: 'Use CSV for large volumes of data; reserve XLS for advanced functions only.'
        },
        delete: {
          really_destroy: 'By marking it, they will be permanently deleted.',
          warning_message: 'These contracts will no longer exist on your list.',
          ont_warning: 'The ONTs linked to the contracts to be deleted will be unauthorized.',
          success_message: 'Contracts have been successfully deleted'
        },
        update: {
          will_update_verb: 'Will update',
          will_updates_verb: 'Will updates',
          update_message: 'The fields to be updated are:',
          recurring_items_and_discounts_hint: 'You can only add up to 24 periods'
        },
        notificate: {
          success_message_one: 'Notification sent correctly.',
          success_message_other: 'Notifications sent correctly.'
        }
      },

      acs_server: {
        change_password: 'Change password',
        change_ssid: 'Change SSID'
      },
      band_2_4_the_device_does_not_support_this_configuration:
        "Band (2.4Ghz) the device doesn't support this configuration",
      band_5_the_device_does_not_support_this_configuration:
        "Band (5.8Ghz) the device doesn't support this configuration",
      // balance: 'Balance C/C',
      breadcrumb_info_paragraph_1: 'Select delimiter, to display correctly separated columns.',
      breadcrumb_info_paragraph_2:
        'The Encoding (or character set), so that special characters, such as accents, are displayed correctly.',
      breadcrumb_info_paragraph_3: 'Then select the file to import, you can view the results below and import it.',
      bulk_actions_successful: 'You will recive an email with the results',
      contracts_deleted_successfully: 'Contracts deleted successfully',
      contracts_imported_successfully: 'Contracts imported successfully',
      errors_found_review_file: 'Errors found in the file, please check the entered data',
      importer: {
        must_select_one_file: 'You must select one file',
        total_contracts: 'Total Contracts',
        contracts_updated: 'Contracts Updated',
        contracts_with_errors: 'Contracts with Errors',
        filter_errors: 'Filter Errors',
        all_errors: 'All errors',
        nap_name: 'Nap',
        nap_port_name: 'NAP Port',
        fiber_code: 'Seal'
      },
      import_contracts: 'Import Contracts',
      import_contracts_count_one: '{{count}} contract will be updated. Are you sure?',
      import_contracts_count_other: '{{count}} contracts will be updated. Are you sure?',
      destroy_contracts: 'Delete Contracts',
      destroy_contracts_count_one: '{{count}} contract will be deleted. Are you sure?',
      destroy_contracts_count_other: '{{count}} contracts will be deleted. Are you sure?',
      process_contracts: 'Process Contracts',
      client_input_placeholder: 'Search by name',
      client_invoicing_disabled: "The contract can't be invoiced.",
      client_invoicing_recurring_item: 'You will not be able to configure the recurring items of this contract.',
      client_invoicing_title: 'Client has <1>invoicing disabled</1>:',
      client_summary: 'Client Summary',
      connecting: 'Connecting',
      contract_config: 'Contract Configuration',
      contract_deleted: 'Contract deleted',
      contract_discount_no_records: 'Without contract discounts',
      cpe_access: 'CPE access',
      create_new_contract: 'Create new Contract',
      credit_amount: 'Credit available in account',
      details_contract: 'Details',
      diagnostics: {
        acs_disabled: 'You need to have this contract linked to a Wispro Box with ACS to use this functionality.',
        address_ip: 'Address IP',
        brand: 'Brand',
        device_offline: 'Diagnostics are not possible because the device is disconnected.',
        diagnostic: 'Diagnostic',
        diagnostic_not_supported: 'The device does not support this diagnostic.',
        mac_address: 'MAC address',
        model_name: 'Model name',
        network_name: 'Network name (SSID)',
        not_mikrotik: 'You need to have this contract linked to a Mikrotik server to use this functionality.',
        offline: 'Offline',
        online: 'Online',
        onu_signal: 'ONU signal',
        ping: {
          ping: 'Ping',
          run_ping: 'Run Ping',
          success_count: 'Packages received',
          failure_count: 'Lost packages',
          loss_percentage: 'Percentage loss',
          ping_statistics: 'Ping Statistics',
          packages_sent: 'Packages sent',
          statistics_legend:
            'Remember that these values may be erroneous if the equipment is not approved. For a better measurement, run the test from the CPE for validation. For better assistance, contact Wispro Support.'
        },
        ping_mkt: 'Mikrotik Ping',
        run_ping_mkt: 'Run Mikrotik Ping',
        serial_number: 'Serial N°',
        speed_test: {
          run_speed_test: 'Run link test',
          speed_test: 'Link test'
        },
        status: 'Status',
        summary_of_the_contract_device: 'Summary of the contract device',
        traceroute: {
          hop: 'Hop',
          ip: 'IP',
          run_traceroute: 'Run Traceroute',
          time: 'Time',
          traceroute: 'Traceroute'
        },
        update_network: 'Update network',
        uptime: 'Uptime',
        you_must_connect_to_the_network_to_view_devices: 'You must connect to the network to view devices'
      },
      disconnecting: 'Disconnecting',
      error_massive_update: 'ERROR1',
      export_classic_error: 'Error in classic export.',
      export_error: 'Error in export.',
      export_no_contracts_filtered: 'No filtered contracts.',
      form_hints: {
        cable_modem_bin: 'Custom cable modem DOCSIS binary file for this contract.',
        cable_modem_dhcp: 'Cable Modem works only for DHCP',
        cable_modem_enabled: 'Works only on Bmu versions greater or equal than 0.7.0.',
        contract_linked_to_ont: 'Contract linked to ONU',
        dhcp_server: 'The DHCP server name must match the one defined on the physical equipment.',
        must_select_an_olt: 'Must select an OLT to select a NAP',
        must_select_a_nap: 'Must select a NAP to select a port',
        nap_select: 'Selecting a NAP will deselect the current Coverage.',
        olt_select: 'In order to change/delete the OLT you must first unauthorize the ONU.',
        olt_traffic_control_not_supported: 'Not supported.',
        onu_id: 'If this field is not completed, it will be assigned by the OLT.',
        subnet: 'Cannot configure Subnet if you activate OLT',
        fully_wispro_effect: 'This field only impacts ONUs configured by Wispro'
      },
      forwarded_port_updated: 'Forwarded port was updated successfully',
      generate_invoice_days: 'Generate invoice on days',
      has_discounts: 'Have {{discounts}} active Discounts',
      has_payment_promises: 'Have {{paymentPromises}} active Payment Promises',
      has_recurring_items: 'Have {{recurringItems}} active Recurring Items',
      has_tickets: 'Have {{tickets}} active Tickets',
      import_statuses_error: 'Import statuses error',
      indicators: {
        active_recurring_items_count: 'Active recurring items',
        active_recurring_items_count_zero: 'No active recurring items',
        pending_tickets_count: 'Pending tickets',
        pending_tickets_count_zero: 'No pending tickets',
        to_apply_discounts_count: 'Active discounts',
        to_apply_discounts_count_zero: 'No active discounts',
        valid_payment_promises_count: 'Valid payment promises',
        valid_payment_promises_count_zero: 'No valid payment promises'
      },
      ip_select_placeholder: 'Find IP free',
      mac_to_use: 'Link ip with',
      massive_update_confirmation_with_params:
        'Of the <0>{{totalContracts}}</0> contracts listed <1>(there are filters applied in: {{filteredParams}})</1>, <2>{{updatedContracts}}</2>, will be updated,',
      massive_update_confirmation_without_params:
        'Of the <0>{{totalContracts}}</0> contracts listed, <1>{{updatedContracts}}</1> will be updated,',
      massive_update_contract_with_errors: '{{error_count}} affected Contract',
      massive_update_contracts_with_errors: '{{error_count}} affected Contracts',
      massive_update_error_detail_message: '{{attr}}: {{error_type}} {{restriction_value}}, {{error_count}}',
      massive_update_error_hint: 'Click on item in the list and filter on table the Contracts with errors',
      massive_update_error_loader_message: 'Retrieving error list',
      massive_update_error_refresh: 'No errors have been found in the massive update.',
      massive_update_error_title: 'Massive Update Errors ({{count}} {{plurality}})',
      massive_update_form_preview_title: 'The data to be updated is:',
      massive_update_process: 'The massive update is in process.',
      massive_update_remove_all_errors: 'Errors in the massive update have been cleaned up.',
      mikrotik_not_linked: 'Mikrotik not linked',
      no_address_interface_mkt: 'The defined IP does not belong to the selected network interface.',
      no_interface_address_mkt:
        'The interface {{interface}} with the address {{address}} does not exist on the device.',
      no_interface_mkt: 'The {{interface}} interface does not exist on the device.',
      olt_plans: 'Available OLT Plans',
      olt: {
        action: {
          add: 'Add',
          authorize: 'Authorize',
          check: 'Check',
          unlink: 'Unlink'
        },
        associate_succesfuly: 'Ont updated',
        auth_ont: 'Authorize ONU',
        authorize_succesfuly: 'Ont authorized',
        connecting_to_olt: 'Connecting to OLT, please wait.',
        disable_catv: 'Disable CATV',
        disable_catv_wait: 'Enabling CATV, please wait.',
        enable_catv: 'Enable CATV',
        enable_catv_wait: 'Disabling CATV, please wait.',
        enable_wan_access: 'Enable WAN access',
        enable_wan_access_wait: 'Enabling WAN access, please wait.',
        disable_wan_access: 'Disable WAN access',
        disable_wan_access_wait: 'Disabling WAN access, please wait.',
        factory_reset: 'Factory reset',
        factory_reset_wait: 'Resetting to factory settings, please wait.',
        no_olts: 'No linked OLTs',
        no_onts: 'No ONUs available',
        onts: {
          alert_description: 'Error description',
          alert_error: 'Error',
          alert_ont: 'F/S/P:Ont',
          alert_time: 'Time',
          alerted_onts: 'ONUs with alerts',
          authorizing: 'Authorizing ONU Serial: "{{serial}}" on {{interface}}: {{number}}',
          board: 'Board',
          contract: 'Contract',
          editing: 'Editing ONU Serial: "{{serial}}" on {{interface}}: {{number}}',
          frame: 'Frame',
          frame_slot_port: 'Frame / Slot / Port',
          full_interface: 'Interface F/B/P',
          gateway: 'Gateway',
          instant_bw: 'Instant',
          ipconfig: 'Configuration type',
          ipconfig_legend: 'Data will be copied from contract',
          ipconfigs: {
            bridge: 'Bridge mode',
            dhcp: 'DHCP',
            pppoe: 'PPPoE',
            static: 'Static'
          },
          massive_unlink_onus: 'Unlink ONUs',
          massive_unlink_onus_description: 'Unlink the ONU from the selected contracts',
          massive_unlinking_process: 'The massive unlinking is in process.',
          massive_unlinking_warning:
            'The ONUs will be unlinked from the selected contracts (the clients will continue browsing).',
          missing_configuration: 'You must complete the missing configuration to authorize.',
          missing_configuration_link: 'You must complete the missing configuration to link.',
          name: 'Name',
          netmask: 'Netmask',
          number: 'Number',
          olt: 'Olt',
          only_auth: 'Only authorization is supported. WAN configuration will be available soon.',
          port: 'Port',
          ports_with_onts: 'GPON Ports with ONUs',
          ports_with_onts_count: '%{count} ports with ONUs',
          profile: 'Profile',
          profile_type: 'Profile Type',
          rules: {
            applying_changes_in_ont: 'Applying changes to the ONU',
            change_state: {
              applied: 'Applied',
              cenceled: 'Canceled',
              error: 'Error',
              pending: 'Applying changes'
            },
            error_applying_changes_in_ont: 'Error applying changes to the ONU',
            kinds: {
              activate: 'Activate ONU',
              activate_catv: 'Activate CATV',
              catv: 'CATV',
              deactivate: 'Deactivate ONU',
              deactivate_catv: 'Deactivate CATV',
              disable_wan_access: 'Disable WAN Access',
              enable_wan_access: 'Enable WAN Access',
              factory_reset: 'Factory Reset',
              reboot: 'Reboot',
              reconfigure: 'Reconfigure',
              resync: 'Resync',
              state: 'State',
              tr069: 'TR069',
              traffic_control: 'Traffic Control',
              unauthorize: 'Unauthorize ONU',
              vlan: 'VLAN',
              wan_provision: 'WAN Provision'
            },
            rule_state: {
              canceled: 'Canceled',
              error: 'Error',
              success: 'Processed',
              pending: 'Pending',
              processing: 'Processing'
            },
            no_changes_currently_applying: 'No changes are currently being applied to the ONU',
            changes_history_title: 'Applied changes history',
            no_changes_applied: 'No changes applied',
            copy_rule_id: 'Copy Rule ID',
            copy_errors: 'Copy errors',
            copy_feedback: 'Copy feedback',
            retry_change_error: 'Error retrying the change',
            change_being_applied: 'The change is being applied'
          },
          serial_number: 'Serial Number',
          service_profile: 'Service Profile',
          show_alerts: 'Show alerts',
          show_changes_applied: 'Changes applied',
          static_ip: 'Static IP',
          tr069: 'Profile TR069',
          tr069_profile_id: 'Profile TR069',
          unsync: 'Unsynchronized ONU',
          unsync_causes: {
            number: 'ONU ID',
            'fbp:n': 'F/B/P:N',
            fbp: 'F/B/P',
            serial_not_found: 'Serial',
            unauthorized: 'Unauthorized',
            unknow: 'Unknown'
          },
          vlan_id: 'Vlan',
          vlans: 'Vlans'
        },
        reboot_ont: 'Reboot',
        rebooting: 'Rebooting the ONU, please wait.',
        resynchronizing: 'Resynchronizing the ONU, please wait.',
        reconfig: 'Overwrite configuration',
        reconfig_wait: 'Overwriting configuration, please wait.',
        reconfig_wan: 'Overwrite WAN configuration',
        reconfig_wan_wait: 'Overwriting WAN configuration, please wait.',
        resync: 'Resynchronize',
        select_ont: 'Should select at least one ONU to associate',
        show_onu_info: 'Show Information',
        unauthorizing: 'Unauthorizing the ONU, please wait.',
        unlink_first: 'First, the current ONU must be unlinked',
        unlinking: 'Unlinking the ONU, please wait.',
        vlans: {
          ip: 'Ip',
          kind: 'Kind',
          name: 'Name',
          netmask: 'Netmask',
          number: 'Vlan id',
          onts_enabled: 'ONUs?',
          server_client_numbers: 'VLAN ID Server <=> Client',
          title: 'Title',
          uplinks_enabled: 'Uplinks?',
          vlan_one_in_use:
            '<0>IMPORTANT!:</0> You use VLAN 1 for authorization. For best practices, it is NOT recommended to use VLAN 1 as a management VLAN or service VLAN. This is a reserved VLAN.',
          vlan_one_in_use_more_info:
            'All interfaces join VLAN 1 by default, it is a bridge configuration of your whole network. This causes packets performing Unicast, Multicast or Broadcast from VLAN 1 to be sent to your whole network and Broadcast storms can happen and your network will be degraded exponentially.'
        },
        wan_provisioning: 'WAN provisioning is disabled.',
        without_permission: 'Without permission'
      },
      // offline: 'Offline',
      one_month: 'Last month of consumption',
      one_week: 'Last week of consumption',
      one_year: 'Last year of consumption',
      // online: 'Online',
      online_contract_error_message: 'We were unable to obtain the number of Contracts connected.',
      ont_linked_info_message:
        'Bandwidth control, automatic CATV status and WAN Provisioning will not be configured because the ONU is linked without reconfiguration.  In order to use them you need to resynchronize the ONU with the Wispro settings.',
      ont_signal: 'ONU Signal',
      ont_number_hint: 'This field will only take effect if the ONU is authorized or reconfigured.',
      other_plans: 'Other plans',
      pagination_info: '{{paginationFilterTotal}} contracts filtered of {{paginationTotalCount}} in total',
      payment_promises_no_records: 'Without payment promises',
      // ping: 'Ping',
      ping_wait: 'Ping in progress, please wait.',
      plan_discount: 'Plan discounts',
      public_address: 'FULL-NAT Address',
      recurring_item_no_records: 'Without recurring items',
      removed_articles_destination: 'Removed articles destination',
      recurring_item_discounts: 'Recurring item discounts',
      resync_contract_to_mkt: 'Resync contract to MikroTik',
      resync_wait: 'Resync in progress, please wait.',
      save_service_invoice: 'Save service invoice',
      search_by_code: 'Search by code',
      search_by_name_or_fbp: 'Search by name or FBP',
      searcher: {
        basic_placeholder:
          'You can Search By: Client Name, Customizable identifier, IP address, Plan name, ONU Serial Number.'
      },
      select_a_port: 'Select a port',
      service: {
        bridge_mode: 'Bridge',
        dhcp: 'DHCP',
        host: 'Host',
        pppoe: 'PPPoE',
        routing_mode: 'Router',
        static: 'Static',
        subnet: 'Subnet',
        router_mode_wan_provisioning_enabled_info:
          'The WAN interface of the ONU is written on the OLT and configured on the ONU via OMCI.',
        router_mode_wan_provisioning_disabled_info: 'The WAN interface of the ONU is configured manually on the ONU.',
        bridge_mode_info: 'The WAN interface of the ONU is configured on the router connected behind the ONU.',
        disabled_routing_mode:
          'It is not possible to change the routing mode because the contract is linked to an ONU configured by Wispro.'
      },
      service_by: 'Service by',
      // should_select_contract: 'Should select contract',
      should_select_contract: 'Should select contract',
      show_client_detail: 'Show client detail',
      show_contract_detail: 'Show contract detail',
      signal_quality: {
        disconnected: 'No signal',
        moderate: 'Moderate',
        strong: 'Strong',
        weak: 'Weak'
      },
      six_months: 'Last 6 months of consumption',
      start_date: 'Start date',
      start_invoicing_date: 'Date to generate next invoice',
      start_invoicing_day: 'Invoice day',
      state: 'Province/State/Region',
      states: {
        alerted: 'Alerted',
        degraded: 'Degraded',
        disabled: 'Disabled',
        enabled: 'Enabled'
      },
      successful_massive_update: 'Contract/s updated',
      this_device_does_not_support_the_requested_service: 'This device does not support the requested service',
      // tabs: {
      //   audits: 'Audits',
      //   details: 'Details',
      //   forwarded_ports: 'Forwarded ports',
      //   invoicing: 'Invoicing',
      //   ont: 'ONU',
      //   payment_promises: 'Payment promises',
      //   pppoe_status: 'PPPoE Status'
      // },
      three_months: 'Last 3 months of consumption',
      tooltip_total_contracts: 'Total number of contracts',
      tooltip_total_contracts_connected: 'Indicates the number of contracts connected to a server {{server}}',
      tooltips: {
        created_at: 'Created at',
        updated_at: 'Updated at'
      },
      unexpected_error_getting_plan_data: 'Unexpected error getting plan data',
      // dhcp_server: 'DHCP Server',
      update_network: {
        update_in_progress: 'Update in progress'
      },
      update_contract_from_file: 'Update contracts from file',
      view_next_invoices: 'view next Invoices',
      wifi: 'WI-FI',
      you_must_bind_an_ont_to_use_this_service: 'You must bind an ONU to use this service'
    },
    contract_discounts: {
      to_apply_discounts: 'Current discounts',
      finalized_discounts: 'Finalized discounts',
      lapse: {
        every_period: 'Every period',
        specific_periods: '{{lapse}} periods'
      }
    },
    cloud_license: {
      unlock_plan_change: 'Unlock plan change',
      acs_license: {
        subscribe: 'Subscribe'
      },
      annual: 'Annual',
      balance_due: 'Balance due',
      balance_in_favor: 'Balance in favor',
      cloud: 'Cloud',
      customer: 'Customer',
      day_of_trial_left: '{{day}} day left of trial',
      days_of_trial_left: '{{days}} days left of trial',
      default_card: 'Default card',
      discount_for_months: {
        one: '{{percentage}}% discount for {{periods}} month',
        other: '{{percentage}}% discount for {{periods}} months'
      },
      extended_license_until: 'Subscription extended until',
      future_discounts_after_trial: {
        one: '{{percentage}}% discount for {{periods}} month will be applied once your trial period ends',
        other: '{{percentage}}% discount for {{periods}} months will be applied once your trial period ends'
      },
      hola_suite: {
        subscribe: 'Subscribe',
        token: 'Token Hola Suite'
      },
      install_cloud: 'Install Cloud',
      installation: 'Instalación',
      invoice: {
        issue_invoice: 'Issue invoice',
        loading_invoices: 'Loading invoices...',
        there_are_no_invoices_to_display: 'There are no invoices to display',
        To_make_a_payment_you_must_create_a_payment_method: 'To make a payment you must add a payment method'
      },
      monthly: 'Monthly',
      past_due_message:
        'We would like to inform you that we have not been able to collect your subscription as of today. Please check if you have sufficient funds or if you need authorization from your bank to avoid subscription expiration.',
      summary: 'Summary',
      support_message: 'If you have any question or inconvenience, please contact our official WhatsApp at: ',
      terms_and_conditions: {
        privacy_policy: 'Privacy Policy',
        privacy_policy_info: {
          changes_to_this_policys_paragraph:
            'Wispro Inc. may change this policy from time to time. If any substantial change is made in the way we use your personal information, we will make that knowledge available by posting a notice on this site.',
          changes_to_this_policys_title: 'Changes to this Privacy Policy',
          choice_opt_out_paragraph:
            'You can choose to “Opt out” of receiving direct marketing or market research information, which means that, unless you take the appropriate steps to “Opt out” of our data collection, we assume that we automatically have the consent to collect and use your information under this policy. “Opt out” signifies that we do not receive your consent to use your personal information for the purposes set forth herein. You can choose to “Opt out” at data collection points when personal information is collected, or may do so at any time by sending an email to support@wispro.co, info (write “Opt Out” in the subject line) or by sending a request by writing to the address below. In some cases, the opportunity to “Opt in” is given. This means that we will require the confirmation of your consent before we use your information other than for the specific purposes requested.',
          choice_opt_out_title: 'Choice / Opt Out',
          contact_info_paragraph:
            'Wispro Inc. is waiting for your comments regarding this Privacy Statement. If you believe Wispro Inc. has not adhered to this privacy statement, please contact us electronically at contacto@wispro.co or by post to the address below, and we will use commercially reasonable efforts to promptly ascertain and solve the problem.',
          contact_info_title: 'Contact Information',
          cookies_and_tracking_paragraph:
            'A “cookie” is a small data file that certain websites write on your hard drive when you visit them. Cookies cannot be used to run programs or to deliver viruses to your computer. A cookie file contains information such as user ID info that the site uses to track the pages you’ve visited within the site, but the only personal information a cookie contains is the information you give it. A cookie cannot read data off of your hard disk or read other archived cookies files created by other websites. Cookies save you time, for example, if you personalize a web page or navigate within a site; a cookie recalls your specific information on a subsequent visit. Wispro Inc. also uses cookies to track user traffic patterns. We do this in order to determine the usefulness of the information we provide on our website and to see how effective our navigational structure is in helping users reach their desired information. You can accept or decline cookies. Most web browsers automatically accept cookies, but you can usually modify your browser setting to decline cookies. Be aware, however, that if a user does not allow cookies as a visitor and/or user, the functionality of the products/services at our website may be limited. In addition to cookies, our site employs a variety of technical methods for tracking purposes like counting visits. Web beacons are small pieces of information that are embedded in images on web pages. Wispro Inc. also uses these technical methods to analyze traffic patterns on our website like the frequency with which our users visit the various parts of our website',
          cookies_and_tracking_title: 'Cookies and Tracking Technology',
          data_collection_paragraph:
            'Personal information means any information that may be used to identify an individual, including but not limited to, a first and last name, company name, email address, phone number, postal or physical address, date of birth, gender, occupation, credit card number (including expiration date) for processing payments for services, application and/or services, and any other necessary information for the provision of the service requested. Some of our products, applications and services also take connection or session information like time/date of visit, length of data entry, IP address, records and technical chat information.',
          data_collection_paragraph_2:
            'As you navigate through our Website and/or use our applications, certain anonymous information can be passively collected (that is, gathered without actively providing the information) through technologies such as cookies, Internet tags, web beacons and navigational data collection (log files, server logs, click stream). Your Internet browser automatically transmits some of this anonymous information, such as the URL of the website you are connected to, Internet Protocol address (IP) and the current version of the browser your computer or mobile is using, as well as the date and time you accessed the Website and the pages you access within the Site. This information is used for internal/external marketing purposes, to analyze trends and improve our website, as well as products, applications and services. Our website may also collect anonymous information from your computer or mobile device through cookies and Internet tags or web beacons. You can always set your browser to notify you when a cookie is accepted or to refuse cookies altogether, but certain features of this site might not work without cookies.',
          data_collection_paragraph_3:
            'Wispro Inc. collects personal information when you choose to use our software on a free trial basis or purchase an application, subscription or an upgrade. Wispro Inc. only uses this information if it has been collected under acceptable privacy practices that are consistent with this Policy and all applicable laws.',
          data_collection_subtitle: 'Data Collection',
          data_security_paragraph:
            'Your personal information is protected for your privacy and security. Wispro Inc. protects the security and confidentiality of the data through physical, technical and administrative procedures. Be aware that, despite our best efforts, no security measures are perfect or impenetrable. Although we strive to protect your personal information, we cannot guarantee the security of your information, so we urge you to take every precaution in protecting your personal data when you are on the Internet. Change your passwords often, use a combination of letters and numbers, and make sure you use a secure browser. ',
          data_security_paragraph_2:
            'Our website may contain links to different websites operated by other companies. Some of these third party sites may be co-branded with the Wispro Inc. logo, even though they are not operated or maintained by Wispro Inc. . Although we choose our business partners carefully, Wispro Inc. is not responsible for the privacy practices of the websites operating as third parties that are linked to our site. Once you have left our website, you should check the relevant privacy policy of the third party website you visit in order to determine how they will handle any information they collect from you.',
          data_security_title: 'Data Security',
          international_privacy_paragraph:
            'The personal information that we keep can be controlled and processed in the United States of America and/or other countries, which do not provide the same level of privacy protection as your country of residence. In order to collect Personally Identifiable Information from users in the European Economic Area and Switzerland, Wispro Inc. adheres to the Safe Harbor Principles administered by the United States Department of Commerce.',
          international_privacy_title: 'International Privacy Protection',
          privacy_for_childrens_paragraph:
            'Our website is for the general public and is not addressed to nor intended for the use of children under 13 years of age. Wispro Inc. does not solicit or keep personal information pertaining to children less than 13 years of age.',
          privacy_for_childrens_title: 'Privacy of Children',
          privacy_policy_paragraph:
            'Wispro Inc. and its subsidiaries, (collectively referred to as "Wispro Inc. ", “we”, “us”, “Company” or “our”), respect your privacy and are committed to protecting your personal information. In general, you can browse through our website without giving us any information about yourself. This policy describes how we collect and use your personal information for various purposes like when we need to provide you our services or when you choose to fill in something on our website (www.Wispro Inc. .info, the “WebSite”) or in our applications (“apps”).',
          revise_review_info_paragraph:
            'You can always request a review of all the personal information we have collected from you in order to keep us updated, to correct or delete this information and/or give us instructions how not to use this information in the future. To exercise this right, simply contact us.',
          revise_review_info_title: 'The ability to revise, review and delete information',
          sharing_info_paragprah:
            'Our website and applications provide the opportunity of “Opting out” of receiving information from us when you choose to use our applications or software on a free trial basis or when purchasing a new subscription or upgrade. Moreover, there is an option of “Opting out” of receiving future information or to change the settings.',
          sharing_info_paragprah_2:
            ' Unless you “Opt in”, Wispro Inc. does not transfer your personal information to third parties unless your expressed consent is given to do so; or, to the extent that it is required by law or in the belief of good faith that this action was necessary in order to: (i) comply with the edicts of the law or comply with a legal process required by Wispro Inc. or the website; (ii) protect or defend the rights or the property of Wispro Inc. ; (iii) act in emergency circumstances to protect the personal safety, property or privacy of Wispro Inc. employees, users of products or services of Wispro Inc. , or members of the public; or (iv) execute a transaction, restructuring or the processing of required information when assets or business are transferred to a third party. If you choose to provide your personal information, we may transfer that information within Wispro Inc. or our third party service providers with your permission. In addition, Wispro Inc. can send your personal information to other companies or people under any of the following circumstances: when we have your consent to share the information; when we need to share your information to provide the service or product that you requested; when we need to send the information to companies who work on behalf of Wispro Inc. to provide a product or service (we only provide those companies the information they need in order to deliver their service and are prohibited from using that data for any other purpose); or we want to keep you up to date on the latest product announcements, software updates, special offers or other information which we think you would like hearing about from us or our business partners (unless you opted out of such communication).',
          sharing_info_paragprah_3:
            'Furthermore, we may share non-identifiable aggregate information about our users (for example, the percentage of male and female users) with advertisers, business partners and other third parties in an effort to customize or enhance the content and advertising on our website for our users.',
          sharing_info_title: 'Sharing and Revealing Information',
          used_collected_data_paragraph:
            'Wispro Inc. uses personally identifiable information for several general purposes: to keep you up to date on the latest announcements for certain products and services, software updates, special offers and other information that we think you would like to hear about, either from us or from our business partners as well as to get a better understanding of your needs and to provide better service. Also, we may use your information to send you promotional material about goods and services (including special offers and discounts) either offered by Wispro Inc. and/or offered by their affiliates. You can opt out of receiving these offers.',
          used_collected_data_title: 'How we use collected data'
        },
        refund_info: {
          money_back_guarantee_paragraph:
            'We have a money back guarantee and you can request a full refund for the software within 15 days after the date of purchase.',
          money_back_guarantee_subtitle: 'Money Back Guarantee',
          process_for_refund_paragraph_1:
            'The following information/steps are necessary for user/subscriber to process the refund:',
          process_for_refund_paragraph_2:
            '1) Subscriber/User Email Address (that corresponds with his/her Wispro Inc. account)',
          process_for_refund_paragraph_3: '2) The details of the invoice which requires reimbursement.',
          process_for_refund_paragraph_4: '3) This information should be sent by email to: contacto@wispro.co',
          process_for_refund_paragraph_5:
            '4) Wait a response from Customer Service confirming that your refund has been issued.',
          process_for_refund_paragraph_6:
            '5) Coordinate the transfer of money in the form requested for the reimbursement.',
          process_for_refund_subtitle: 'Process for Refund',
          refund_policy_title: 'Refund Policy'
        },
        refund_policy: 'Refund Policy',
        terms_and_conditions: 'Terms and Conditions',
        terms_and_conditions_info: {
          accepted_payment_methods_paragraph_1: '3.1.1. Monthly Payment Subscriptions.',
          accepted_payment_methods_paragraph_1_1:
            'In cases where your subscription to a service is on a monthly basis, payment of the subscription fee must be charged to a pre-authorized credit card or account and your subscription will automatically renewed each calendar month, unless you provide Wispro Inc. with written notification of non-renewal during the prior calendar month.',
          accepted_payment_methods_paragraph_2: '3.1.2. Yearly Payment Subscriptions:',
          accepted_payment_methods_paragraph_3:
            '3.1.2.1 Yearly subscriptions by credit card. In the case that your Service subscription is for one year and the initial payment is made by credit card, or direct debit, your subscription will automatically renew at the beginning of each subsequent yearly anniversary date unless Wispro Inc. is given written notice of non-renewal at least thirty (30) days before the expiration of your current subscription year.',
          accepted_payment_methods_paragraph_4:
            '3.1.2.2. Yearly subscription by invoice. In the case that your Service subscription is for one year and the initial payment is made by check or money order with an invoice from Wispro Inc. , payment will be due within thirty (30) days of the date of the invoice. Furthermore, your subscription will automatically renew at the beginning of each anniversary year unless you or Wispro Inc. provide written notice of non-renewal at least thirty (30) days prior to the expiration of the current subscription year.',
          accepted_payment_methods_paragraph_5:
            '3.1.3. Free Subscriptions. Contrary to the above, your subscription to any of the free services provided by Wispro Inc. does not require a subscription fee payment. Wispro Inc. reserves the right, at its sole and absolute discretion, to restrict, limit, or terminate the use of “Free” or “Basic” Services by any person, entity or group of entities.',
          accepted_payment_methods_subtitle: '3.1 Accepted Payment Methods',
          account_use_title: 'Article II. Account Use',
          additional_conditions_title:
            'Article VI. Additional Conditions for remote access, Management Services and Support.',
          applicable_law_paragraph_1:
            'The Terms shall be governed by and construed in accordance with the state laws of Santiago and the national laws of Chile, without giving effect to any principles of conflicts of law. You agree that any action arising out of or relating to these Terms shall be filed only in the state or federal courts located in Santiago, Chile, and you consent and submit to the personal jurisdiction of such courts for the purposes of litigating any action. The parties expressly waive the applicability of (i) the United Nations Convention on the Sale of Goods and (ii) any Incoterms.',
          applicable_law_subtitle: '5.2. Applicable Law.',
          characteristics_paragraph_1: 'Software management and administration for ISPs.',
          characteristics_paragraph_2:
            'The software solves technical and administrative issues for Internet Service Provision to customers or end users.',
          characteristics_paragraph_3: 'The techniques are:',
          characteristics_paragraph_4:
            '– Balancing and Fail Over for multiple connections: giving the possibility of balancing multiple ISP WANs.',
          characteristics_paragraph_5: '— QoS and P2P control.',
          characteristics_paragraph_6: '— Web and Video Cache.',
          characteristics_paragraph_7: '— PPPoE.',
          characteristics_paragraph_8: '— Control over bandwidth users and plans. Graphics consumption.',
          characteristics_paragraph_9: '— Permanent Online Updates. NAT Balancing. Download Speeds.',
          characteristics_paragraph_10:
            '— Handling of public IP for Full NAT, Proxy ARP, routed. Dynamic DNS. DHCP. Control x timetable.',
          characteristics_paragraph_11:
            'The management is through: Task Delegation. Auditing. Users with permission profiles. Remote Access Web Application. Automated Processes. Notification of delays and automatic cutting of delays. Captive Portal for the ISP customer. One-time Commercial Notifications. Support and Helpdesk for ISP customers. Task Assignment. Issue Tracking. Reports. Billing. Billing and Printing. Management of Payments and Collections. Electronic Payment Importation.',
          characteristics_paragraph_12: 'These features are only illustrative and not definitive.',
          characteristics_paragraph_13:
            'It is understood that the use of this software involves a business in which you charge users, and therefore must comply with all legal provisions and regulations that governs such activity.',
          characteristics_paragraph_14: 'You agree that there will be NO:',
          characteristics_paragraph_15:
            '(i) Violation of international rules that provide a base for the Internet, which are to be understood in a broad and comprehensive manner.',
          characteristics_paragraph_16:
            '(ii) Use of the software or service for the resale of the Internet in violation of local or international standards.',
          characteristics_paragraph_17:
            'You agree to the responsibility for the acts and omissions of your employees and consultants and will use commercially reasonable efforts to monitor your employees.',
          characteristics_paragraph_18:
            'Wispro Inc. reserves the right to deactivate your account or take any other action that Wispro Inc. deems, at its sole discretion, as necessary or appropriate, including legal action, if Wispro Inc. has reason to believe that you have violated the terms of this Section.',
          characteristics_subtitle: '6.1. Characteristics.',
          comments_paragraph_1:
            'Wispro Inc. has worldwide, perpetual, royalty-free license for the use or the incorporation of the suggestions, ideas, enhancement requests, recommendations or other information provided by you into the Services or pertaining to the operation of the Services (“Comments”).',
          comments_subtitle: '4.6. Comments',
          confidentiality_paragraph_1:
            'You must maintain confidentiality of the information that has been and will continue to be provided to You by Wispro Inc. in connection with your use of the Service. You expressly agree to the following terms of confidentiality (the “Terms of Confidentiality”):',
          confidentiality_paragraph_2:
            '4.7.1. Obligations. You must (a) maintain the confidentiality of all information, including but not limited to, the Service and the related software, (b) not disclose this information to anyone except your employees, agents and consultants on a need to know basis (and have been informed and recognize their obligation to be bound by these confidentiality terms), and © not use Wispro Inc. confidential information for any purpose other than that for which it was disclosed. All confidential information will remain the exclusive property of Wispro Inc. . You have no right, title or interest in/to the confidential information.',
          confidentiality_paragraph_3:
            '4.7.2. Confidential information. Information considered confidential by Wispro Inc. includes, without limitation, Wispro Inc. information regarding (a) technical issues such as trade secret processes or devices, know-how, data, formulas, inventions (patentable or not, or copyrights), specification and characteristics of research products, services, methods or results, (b) business issues, such as information on budget, benefits, prices, policies, markets, sales, suppliers, customers, plans, or products in development or planned, as well as business concepts, plans or strategies, © questions concerning the nature of human resources, such as employment policies and practices, personnel, compensation and employee benefit resources, (d) any other information of a similar nature that has not been generally disclosed by Wispro Inc. to the public or any other information that you should reasonably believe is confidential, under the circumstances, (e) information relating to your use of the Service, and (f) the service itself and its associated software.',
          confidentiality_paragraph_4:
            '4.7.3. Exclusions. The obligations imposed by these terms of confidentiality shall not apply to any information that (a) has been shown to have been lawfully obtained by you from a third party without the accompanying use or disclosure of restrictions; (b) is or is generally made available or the public through no wrongful act by You or any other person or entity with a confidentiality obligation; © is already known by you prior to the date of disclosure as evidenced by documentation bearing a date prior to the date of disclosure; (d) is approved for release proven in writing by an authorized representative of Wispro Inc. ; (e) or is required to be disclosed due to a valid court order, duly authorized by subpoena, or governmental authority (you must always provide immediate written notice to Wispro Inc. when a situation such as this arises about the required disclosure).',
          confidentiality_paragraph_5:
            '4.7.4. Compensation. The solution for any breach of law of any of the agreements and accords set forth in these confidentiality terms may be insufficient, so that in the case of any breach or threatened breach, Wispro Inc. shall, in addition to all other solutions which may be available for the law, pursue the right to fair compensation in the form of preliminary and permanent injunctions without the necessity of proof of the damages. Furthermore, you agree that these conditions of confidentiality shall not restrict or limit any other solution that may be available to Wispro Inc. by law and that Wispro Inc. may be entitled to recover its costs, including reasonable attorney’s fees, to enforce their rights under these confidentiality terms.',
          confidentiality_paragraph_6:
            '4.7.5. Return of Confidential Information. By written request of Wispro Inc. , you must return or prove that you destroyed all information disclosed in these confidentiality terms along with any memorandum, diagrams or any other documentation containing any disclosed information in these confidentiality conditions',
          confidentiality_paragraph_7:
            '4.7.6. Enforceability. If one or more provisions of these confidentiality conditions are deemed invalid, illegal or unenforceable, in any respect, the validity, legality and enforceability of the remaining provisions contained herein shall not in any way be affected or impaired.',
          confidentiality_paragraph_8:
            '4.7.7. Application. These confidentiality conditions shall control in place of and without prejudice to the inscriptions or statements of ownership or the incompatible confidentiality condition restrictions that may be associated with any particular information described herein.',
          confidentiality_paragraph_9:
            '4.7.8. Surviving Obligations. The confidentiality obligations imposed by these confidentiality terms shall survive any termination, expiration or cancellation of these Terms or your subscription period, in addition to continuing beyond any moment that the Service was used.',
          confidentiality_subtitle: '4.7. Confidentiality',
          credit_card_auth_paragraph_1:
            'In the case that you cancel the credit card you use to pay for the Wispro Inc. service or the card expires or is terminated for any reason, you should immediately provide Wispro Inc. with a new valid credit card number. You authorize Wispro Inc. , occasionally, to undertake the necessary steps to determine if the credit card number provided to Wispro Inc. is a valid. In the case that you do not provide Wispro Inc. with a valid credit card number with a sufficient amount of credit upon request during the validity period of these Conditions, you will be in violation of these Terms. You authorize Wispro Inc. to automatically update your credit card information through software designed for the purpose of such update.',
          credit_card_auth_subtitle: '3.3. Credit Card Authorization',
          disclaimer_of_risk_activity_paragraph_1:
            'The Services are not fault-tolerant and are not designed, manufactured or intended for use or resale as control equipment or for hazardous online environments that require proof performance failures, including but not limited to, equipment used to operate nuclear facilities, communication systems and air transport aircraft or air traffic control, direct life support machines or weapons systems, in which the failure of services could lead directly to death, personal injury or physical or severe environmental damage (“High Risk Activities”). As a consequence of this, Wispro Inc. and its suppliers specifically disclaim any expressed or implied guarantee of applicability for such High Risk activities.',
          disclaimer_of_risk_activity_subtitle: '4.8. Disclaimer of High Risk Activity',
          divisibility_paragraph_1:
            'If any provision of these Terms shall be unlawful, void, or for any reason unenforceable, then that provision shall be deemed severable from these Terms and shall not affect the validity and enforceability of any remaining provisions.',
          divisibility_subtitle: '5.3. Divisibility.',
          entire_agreement_condition_paragraph_1:
            'Wispro Inc. may modify these Terms at any time through (i) the publication of revised documented conditions (ii) sending information about the term amendments to the email address that you provided us. You are responsible for regularly reviewing the site to be aware of such changes.',
          entire_agreement_condition_subtitle: '5.1. Entire Agreement Condition',
          final_user_conduct_paragraph:
            'You are solely responsible for the content of your computer(s) and your Wispro Inc. account and the transmissions sent using the Services. Your use of the Services are subject to the terms set forth herein and all applicable laws, rules and regulations, including local, state, national and international laws, rules and regulations (including and without limitation to those governing privacy, collection accounts, export control, consumer protection, unfair competition, antidiscrimination or false advertising). By using any of the present Services, you accept: (i) compliance with all laws, rules and regulations (including and without limitation to those governing privacy, collection accounts, export control, consumer protection, unfair competition, antidiscrimination or false advertising); (ii) not using the Service to post, distribute, or otherwise make available or transmit any software or other computer file that contains a virus, Trojan, worm or other harmful or disruptive component; (iii) not using the Service for illegal purposes; (iv) not eliminating the Service or its associated software, documentation or any website Wispro Inc. used in connection with the Service, any legal notices, disclaimers, or proprietary items, such as copyright or trademark notices, or modify any logos not owned or have expressed permission to modify; (v) not using the Service for interfering or interrupting other networks connected to the Service; (vi) not using the Service to infringe the copyrights of others, patents, trademarks, trade secrets or any other proprietary rights or rights of publicity or privacy; and (vii) not using the Service to distribute any unlawful, harassing, libelous, defamatory, racist, indecent, abusive, violent, threatening, intimidating, harmful, vulgar, obscene, offensive or objectionable material of any kind or nature. You may not access or use another person’s Wispro Inc. account at any time without first obtaining the permission of the account holder. You agree that you are responsible for all actions and omissions of your employees, consultants, or other third parties that you allow to access to your Wispro Inc. account, and you agree to use commercially responsible efforts to control these third party users. Wispro Inc. reserves the right to deactivate your account or take any other action that Wispro Inc. deems necessary or appropriate, at its sole discretion, when Wispro Inc. has reason to believe that your conduct has violated the terms of this Section 2.2 while using any of the Services.',
          final_user_conduct_subtitle: '2.2. Final User Conduct',
          force_majeure_paragraph_1:
            'Wispro Inc. will not be liable for any failure of performance, delay in performance, or data loss under these Terms (other than for delay in the payment of money due and payable below) to the extent said failures or delays are caused directly by: (i) software failures or any other computer program error (other than that which is the purchased service), (ii) natural weather events, o (iii) any other cause beyond the reasonable control of this entity and occurring without its fault or negligence, including and without limitation to the failure of suppliers, subcontractors and carriers, provided that, in any case, as a condition for the waiver of the claimed fee, the party that experiences the difficulty immediately gives the other party written notice with all the details after the occurrence of the alleged cause.',
          force_majeure_subtitle: '4.10. Force Majeure.',
          guarantee_disclaimer_paragraph_1:
            'Although Wispro Inc. has attempted to provide accurate information regarding the Service, Wispro Inc. assumes no responsibility for the accuracy or inaccuracy of any of the information provided. Mention of Wispro Inc. products or services is for informational purposes only and constitutes neither an endorsement nor a recommendation. The use of any of the Services is at your own risk. ALL INFORMATION, DOCUMENTS AND SERVICES PROVIDED BY Wispro Inc. ARE PROVIDED “AS IS” WITHOUT ANY KIND OF GUARANTEE, EXPRESSED OR IMPLIED. Wispro Inc. INTENTIONALLY DISCLAIMS ALL WARRANTIES, CONDITIONS, REPRESENTATIONS AND GUARANTEES WITH RESPECT TO THE SERVICE, WHETHER EXPRESSED OR IMPLIED, RELATED TO LAW, CUSTOM, PREVIOUS written or oral descriptions, OR FROM ANY OTHER MEANS. Wispro Inc. DOES NOT GUARANTEE THAT THE SERVICE WILL MEET YOUR REQUIREMENTS OR THAT THE SERVICE WILL BE UNINTERRUPTED, TIMELY OR WITHOUT ERROR. NEITHER DOES Wispro Inc. PROVIDE ANY GUARANTEE AS TO THE RESULTS THAT MAY BE OBTAINED FROM THE USE OF THE SERVICE OR THE ACCURACY OF ANY INFORMATION OBTAINED THROUGH THE SERVICE. YOU ACKNOWLEDGE AND ACCEPT THAT ANY MATERIAL AND/OR DATA DOWNLOADED OR OTHERWISE OBTAINED THROUGH THE USE OF THE SERVICE IS DONE AT YOUR OWN RISK AND THAT YOU WILL BE SOLELY RESPONSIBLE FOR ANY DAMAGE DONE TO ANY COMPUTER SYSTEM OR LOSS OF DATA THAT RESULTS FROM THE DOWNLOAD OF SUCH MATERIAL AND/OR DATA. NO REPRESENTATION OR OTHER AFFIRMATION OF FACT, INCLUDING AND WITHOUT LIMITATION TO STATEMENTS REGARDING CAPACITY, SUITABILITY OF USE OR PERFORMANCE OF THE SERVICES, WHETHER MADE BY EMPLOYEES OF Wispro Inc. OR OTHERWISE, which is not part of this agreement, shall be deemed as guarantee BY Wispro Inc. FOR ANY PURPOSE, SHALL GIVE RISE TO ANY TYPE OF LIABILITY WHATSOEVER.',
          guarantee_disclaimer_subtitle: '4.1. Guarantee Disclaimer.',
          ilicit_use_paragraph_1:
            'Wispro Inc. is not responsible for illicit use of the Internet in any way, since Wispro Inc. does not distribute or sell the Internet to users.',
          ilicit_use_subtitle: '6.3. Illicit Use.',
          laws_of_chile_subtitle:
            '4.9. Compliance with Service Export Laws and Regulations of related software are subject to the laws of Chile.',
          legal_terms_title: 'Article IV. Legal Terms',
          licensing_paragraph:
            'Wispro Inc. grants you a royalty-free, non-exclusive, worldwide, non-transferable license to access and use the software subject to the restrictions set forth in these present Terms and Conditions. The service is owned and operated by Wispro Inc. and provided to you by subscription; Wispro Inc. is not transferring ownership or proprietorship of the service.',
          licensing_sub_item_paragraph_1:
            '2.1.1. The service is only available for download for use by you and only in accordance with these Terms. Any reproduction, resale or redistribution of the service not in accordance with these conditions is strictly prohibited and may result in civil suits and penalties. Violators will be prosecuted to the maximum extent possible. The license granted may not be transferred by you to a third party and is not exclusive.',
          licensing_sub_item_paragraph_2:
            '2.1.2. You acknowledge that the Services and the Software are property of Wispro Inc. and/or their suppliers and are protected by Copyrights, trademarks, service marks, patents and/or other proprietary rights and laws. You may not remove any Authorial notices or labels from any of the Services. You may not alter, modify, distribute, sell, auction, decompile, reverse engineer, disassemble or reduce any of the Services into a readable format. You may not reproduce, distribute or create derivative works based on the Services without expressed authorization to do so in writing from Wispro Inc. . In addition, you may not rent, lease, grant a security right or transfer any other right of the Services. All rights not expressly granted in these terms are reserved to Wispro Inc. and their suppliers.',
          licensing_sub_item_paragraph_3:
            '2.1.3. The license granted under these stipulations entitles you to receive any and all updates and support that Wispro Inc. delivers as standard to all users of their services in general. Notwithstanding the above, Wispro Inc. reserves the right to charge the full amount of their fees to users of future versions. You understand that Wispro Inc. can update or amend any of the services and related software at any time, but has no obligation to inform you of any such changes or modifications. In order to avoid any doubt, and unless Wispro Inc. chooses to provide such changes and modification to all users, these Conditions do not grant you any right, license or interest in the maintenance, upgrades, modifications, enhancements or updates to the Services or the related software for any premium or “VIP” support. To the extent that Wispro Inc. delivers updates or enhancements to you, they will be considered subject to these terms, unless Wispro Inc. indicates otherwise.',
          licensing_sub_item_paragraph_4:
            '2.1.4. ANY AND ALL CONTENT OF THE PROGRAMS ON THE WEB SITES, software and associated equipment are protected by copyright and other intellectual property laws. With the exception of prior consent, NO INFORMATION OR CONTENT OF THESE WEBSITES, software or information programs may be reproduced in any form or by any means without the previous written permission by Wispro Inc. . YOU OR ANY OTHER VISITOR OR USER are not authorized to modify, distribute, publish, transmit or create derivative works of any of the material found on these web pages, software or informatics programs FOR ANY PUBLIC OR COMMERCIAL PURPOSE.',
          licensing_subtitle: '2.1. Licensing',
          limitations_of_liability_paragraph_1:
            '4.2.1. YOU AGREE TO THE CONSIDERATION THAT BY Wispro Inc. RECEIVING THE PRESENT, DOES NOT INCLUDE THAT Wispro Inc. ASSUMES RISK FOR YOUR INCIDENTAL, CONSEQUENTIAL, SPECIAL OR OTHER INDIRECT DAMAGES. Wispro Inc. AND ITS SUPPLIERS ARE NOT RESPONSIBLE FOR ANY INCIDENTAL, CONESQUENTIAL, SPECIAL OR OTHER INDIRECT DAMAGES, INCLUDING AND WITHOUT ANY LIMITATION TO THE LOSS OF PROFITS OR REVENUES, COST OF PRODUCTS OR SUBSTITUTE SERVICES, THE LOSS OR DAMAGE OF INFORMATION OR DATA ARISING FROM THE USE OR THE INABILITY OF USE OF THE SERVICE. UNDER NO CIRCUMSTANCES, INCLUDING BUT NOT LIMITED TO NEGLIGENCE, IS Wispro Inc. RESPONSIBLE FOR DAMAGE CAUSED BY THE USE OF THE SERVICE, OR THE RELIANCE ON THE INFORMATION PRESENTED IN CONNECTION WITH THE SERVICE, EVEN IF Wispro Inc. OR ITS SUPPLIERS HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. YOU AGREE NOT TO MAKE ANY CLAIMS AGAINST Wispro Inc. OR ITS SUBSIDIARIES OR AFFILIATES OR THEIR RESPECTIVE OFFICERS, DIRECTORS AND EMPLOYEES.',
          limitations_of_liability_paragraph_2:
            '4.2.2. YOU AGREE THAT THE USE OF THE SERVICE IS AT YOUR OWN RISK. IN NO EVENT SHALL Wispro Inc. BE RESPONSIBLE FOR DAMAGES, LOSSES AND CAUSES OF ACTION (WHETHER IN CONTRACT, OFFENSE OR OTHERWISE) THAT EXCEEDS THE AMOUNT PAID TO Wispro Inc. , IN ANY CASE, FOR THE SERVICE DURING THE 12 MONTHS IMMEDIATELY BEFORE THE CLAIM. IN THE CASE THAT THE APPLICABLE LAW LIMITS THE EXCLUSION OF IMPLIED GUARANTEES OR THE LIMITATIONS OF LIABILITY, THE MAXIMUM AMOUNT OF PERMITTED EXCLUSION FOR THE APPLICABLE LAW APPLIES.',
          limitations_of_liability_paragraph_3:
            '4.2.3. ALL DISCLAIMERS, LIMITATIONS OF GUARANTEES, DAMAGES AND CONFIDENTIAL UNDERTAKINGS SET FORTH IN THESE TERMS OR OTHERWISE EXISTING AS LAW (1) ARE OF THE ESSENCE OF THE AGREEMENT OF THE PARTIES, AND (2) shall survive any termination, expiration, or cancellation OF THESE TERMS.',
          limitations_of_liability_subtitle: '4.2. Limitation of Liability and Damage.',
          no_cancelations_paragraph_1:
            'Contrary to of any provision of these Terms or any course of business between parties, you cannot cancel, terminate or rescind your subscription before its expiry date. Any and all payments by you to Wispro Inc. for access to the Services are final.',
          no_cancelations_subtitle: '3.2. No Cancelations.',
          non_exclusivity_paragraph_1:
            'You acknowledge and agree that Wispro Inc. is in the business of providing solutions for ISPs and that Wispro Inc. can provide these services to other third parties, including your potential competitors, which are identical or similar to the services that you provide herein.',
          non_exclusivity_subtitle: '5.7. Non Exclusivity',
          notifications_paragraph_1:
            'Wispro Inc. may send notifications to the email address that you provided on the registration form or by any other means that Wispro Inc. determines at its sole discretion. IF you want to send Wispro Inc. any notice in connection with these terms shall be in writing and sent by first class or certified mail (receipt is deemed 72 hours after postage and with return receipt upon request) or personally delivered to the address of the Wispro Inc. set forth herein.',
          notifications_subtitle: '5.5. Notifications.',
          ownership_paragraph_1:
            'The ownership, the rights of property and the rights of intellectual property in the Service will be the property of Wispro Inc. or its suppliers, accordingly. The Service is protected by copyright and other intellectual property laws and international treaties. Title and related rights in content accessed through the Service is the property of the content owner and is protected by applicable law. The licenses granted under these Terms give you no rights over this content. "Wispro Inc. ", the associated logos, and other names, logos, icons and marks identifying Wispro Inc. services are trademarks or service marks of Wispro Inc. (collectively the “Trademarks”) and may not be used without prior written permission by Wispro Inc. . All other product names mentioned are only used for identification purposes and may be trademarks or service marks of their respective owners. Nothing should be construed as granting, by implication, disqualification, or otherwise, any license or right to use any trademark without the written permission of Wispro Inc. or the third party that may own the Marks. The use of the trademarks, except within the provision of these Terms, is strictly prohibited.',
          ownership_subtitle: '4.5. Ownership',
          password_and_securuty_paragraph:
            'Certain services provided by Wispro Inc. herein require the use of an email address to create a username and the choice of a password to gain access to your Wispro Inc. account (for security reasons, Wispro Inc. recommends choosing a password for the service that is different from the username and password for your computer). Wispro Inc. will not send emails asking for Wispro Inc. usernames and/or password information from any user or username. In order to maintain security, you should keep all usernames and passwords confidential. Access to and the use of the parts of the Services protected by password and/or the security are limited to the authorized users. Unauthorized individuals attempting to use any of the Services may be subject to prosecution. You agree to carefully safeguard all of your passwords. Wispro Inc. does not maintain a database of user passwords, which makes you solely responsible if you do not maintain the confidentiality of your passwords and account information. Furthermore, you are solely responsible for any and all activities that occur under your account. Wispro Inc. is not responsible for any losses incurred by you as a result of your use of another password, account, or public/private key, as may be the case, either with or without your knowledge. However, you may be liable for losses incurred by Wispro Inc. or another party due to the use of your password, account, or public/private key of another person, as may be the case, either with or without your knowledge. You agree to immediately notify Wispro Inc. of any unauthorized use of your account or any other suspected violation of security, which includes if you believe your password and/or account information has been stolen or otherwise compromised.',
          password_and_securuty_subtitle: '2.3. Passwords and Account Security',
          payment_due_date_paragraph_1:
            'Except as otherwise provided herein, payment of all due fees are to be made to Wispro Inc. without demand, invoicing or notice before the start of the subscription period to which these fees apply.',
          payment_due_date_subtitle: '3.5. Payment Due Date.',
          paypal_pay_paragraph_1: 'Wispro Inc. doesn’t accept payments through PayPal.',
          paypal_pay_subtitle: '3.4. PayPal® payments.',
          personal_info_paragraph:
            'When using certain Service(s) provided by Wispro Inc. , it is possible that you may need to exchange a limited amount of Personal Identifiable Information (“PII”) with Wispro Inc. . Your consent to these Terms constitutes an understanding and expressed agreement that when PII is provided to Wispro Inc. in relation to their Services, it is through any of the Wispro Inc. websites.',
          personal_info_subtitle: '1.2. Personal Identifiable Information.',
          publicity_paragraph_1:
            'Wispro shall have the right to identify you as a user of the Service. It expressly authorizes advertising on a map geolocating the user of the service according to the address provided by them in the registration form.',
          publicity_subtitle: '5.4. Publicity.',
          reparations_paragraph_1:
            'You are responsible for maintaining the confidentiality of your account and password(s). You are also responsible for all activities that occur under your account. Therefore, You agree to compensate for, defend and hold Wispro Inc. and its suppliers, affiliates, employees, officers, directors, owners, information, agents, licensees, licensors (the “Indemnified Parties”) from and against any and all liability, claims, costs, including reasonable attorney’s fees incurred by the Indemnified Parties in connection with any claims of third parties, demands, actions, suits or loss arising as a result of (a) any breach of these terms of use by you or claims arising from your account; (b) any fraud or manipulation on your part; © a third party claim, action or allegation of infringement based on information, data files or other content submitted by you; or (d) any claims of credit card fraud based on the information published by you. You agree to your best efforts to cooperate with the countries where Wispro Inc. operates in the defense of any suit, claim, action or demand. Wispro Inc. reserves the right to assume the exclusive defense and control of any matter for which you are required to indemnify Wispro Inc. , and in such case you agree to cooperate with Wispro Inc. ’s defense of such claim.',
          reparations_subtitle: '4.3. Reparations.',
          sales_promo_offers_etc_paragraph_1:
            'Sales, promotions and other special discount offers are temporary and the renewal of your subscription pertaining to these discounted prices can expire. Wispro Inc. reserves the right to discontinue or change any coupons, credit, sales and special promotions at its discretion.',
          sales_promo_offers_etc_subtitle: '3.7. Sales, Promotional offers, Coupons, Credits.',
          saving_navigational_info_paragraph_1:
            'Wispro Inc. is not responsible for the breach of current local or international regulations regarding the storage of the navigation information of the ISP users.',
          saving_navigational_info_subtitle: '6.2. Saving Navigational Information.',
          service_data_paragraph:
            'By using Wispro Inc. Services, you can access, collect, transmit, store and share certain data, information, files, etc. (in the “Data Service”). Wispro Inc. does not own any Data Services Data and disclaims any liability for any Data Services Data that you or any other user collected and produced by using the Service. Wispro Inc. accepts that these Conditions do not confer any ownership rights to Wispro Inc. Data Service.',
          service_data_subtitle: '1.3. Service Data',
          taxes_paragraph_1:
            'You agree to be responsible and pay any applicable sales, personal property, use, VAT, excise, withholding, or any other tax that may be imposed, as of this License or the use or possession of a Service, or any software or other product under these terms, excluding taxes based on the net revenue of Wispro Inc. . If you are exempt from paying any sales, use or other taxes, you must provide supporting evidence to Wispro Inc. with proof of tax exemption for all relevant jurisdictions.',
          taxes_subtitle: '3.6. Taxes.',
          term_and_termination_paragraph_1:
            'Wispro Inc. can, at its sole discretion, immediately cancel your subscription, license and right to use the Service if (i) you can not make timely payments of subscription fees as required for access to your account or by declaring bankruptcy, being involved in bankruptcy proceedings or by being insolvent; (ii) breach of these Terms; (iii) Wispro Inc. can not verify or validate any information that was provided to Wispro Inc. ; or (iv) Wispro Inc. decides, at its sole discretion, to stop offering the service to its users. Wispro Inc. is not liable to you or any third party for the termination of Service or the use of the Service. Upon the termination or expiration for any reason, you are no longer authorized to use the Service. When your access to the Service is finished and/or your subscription is cancelled, you no longer have access to data and the other materials you may have stored in connection with the Service, and Wispro Inc. may delete that material. All disclaimers, limitations of guarantees and damages, and confidential commitments set forth in these Terms or otherwise existing by law survive any termination, expiration or cancellation of these Terms.',
          term_and_termination_subtitle: '4.4. Term and Termination.',
          terms_and_conditions_info_paragraph:
            'IMPORTANT — PLEASE READ THESE TERMS AND CONDITIONS OF BUYING AND USING OUR VALUED SERVICES AND/OR SOFTWARE OF Wispro Inc.',
          terms_and_conditions_info_paragraph_2:
            'These terms and conditions (“Terms”) regulate the use and license of Wispro Inc. ® SuperCache ®, (in conjunction, the “Services”, and each “Service”). Each service can have terms and conditions that are unique to their functions and additional particular characteristics. We ask you to read the specific Terms and Conditions of service before buying or using any service. By completing the subscription process by pushing the “Send” or “Accept” button for using whichever of the Services, INDICATES THE ACCEPTANCE OF THESE TERMS AND DECLARES AND GUARANTEES THAT: (i) YOU ARE AUTHORIZED TO BIND YOURSELF AND ANYOTHER PERSON IN WHOSE NAME IS REFERENCED IN THE USE OF THE SERVICE AND/OR THE SOFTWARE ; (ii) YOU AGREE TO BE BOUND BY ALL OF THESE TERMS, INCLUDING THE EXCLUSION OF GUARANTEES AND LIMITATION OF LIABILITIES SET FORTH IN THE FOLLOWING with the exclusion of any other rights and obligations.',
          terms_and_conditions_info_title: 'Terms and conditions for the use of Sequrelsp cloud services',
          terms_fees_renewals_title: 'Article III. Terms, Fees, and Payment Renewals',
          terms_of_assigment_paragraph_1:
            'Wispro Inc. may transfer this Agreement without the prior written consent in connection with a merger, acquisition, change of control, or the substantial sale of all of its assets (or any substantially similar transaction). In addition, Wispro Inc. may delegate all or part of the execution of this Agreement to an investee, without your prior consent and without expression in writing.',
          terms_of_assigment_subtitle: '5.8. Terms of Assignment.',
          various_terms_of_service_title: 'Article V. Various Terms of Service.',
          waiver_paragraph_1:
            'You agree not to submit or participate in any class action against Wispro Inc. or any of its employees or affiliates. You agree not to file a claim under these Terms for more than two years after the expiration of these Terms.',
          waiver_subtitle: '5.6. Waiver',
          your_data_paragraph:
            'In order to use the Services, the Client must complete and submit a registration form online (the “Registration Form”). As part of the registration process, you accept: (i) that certain limited information about yourself will be taken as prompted during the registration process or later by the Service (such information must be current, complete and accurate) and (ii) this information will be maintained and updated as necessary in order for the data to remain complete and precise. The information solicited during the initial signup is known as the “Data Account”. Wispro Inc. can have limited access to this data in order to store, create, share or display throughout the Service that data which is to be used exclusively to provide the Service. The Privacy Policy states how the Data Account may be collected, used and disposed. You must be at least 18 years of age in order to register. If Wispro Inc. discovers that any part of the Data Account is incorrect, incomplete or not up to date, or if Wispro Inc. determines, at their discretion, that you are not a subscriber or a proper user of the service, Wispro Inc. may immediately terminate your right to access, receive, use and authorize the Service and the related software.',
          your_data_subtitle: '1.1. Data Account',
          your_data_title: 'Article I. Your Data'
        }
      },
      title: 'Dear Wispro user',
      transactions: {
        loading_transactions: 'Loading transactions...',
        status: {
          failed: 'Failed',
          pending: 'Pending',
          refunded: 'Refunded',
          succeeded: 'Success'
        },
        there_are_no_transactions_to_display: 'There are no transactions to display',
        transaction: {
          approved_by_network: 'Approved by Network',
          authorized: 'Authorized',
          blocked: 'Blocked',
          declined_by_network: 'Declined by Network',
          elevated: 'Elevated',
          failure_code: {
            approve_with_id: 'Payment cannot be processed',
            call_issuer: 'Card declined',
            card_declined: 'Card Declined',
            card_not_supported: 'Card is not supported',
            card_velocity_exceeded: 'Your are exceeded credit limit available in the card',
            currency_not_supported: 'Currency not supported',
            do_not_honor: 'Card declined unknown reason (1). Please contact your bank.',
            do_not_try_again: 'Card declined unknown reason (2). Please contact your bank.',
            duplicate_transaction:
              'A transaction with identical amount and credit card information was submitted very recently',
            expired_card: 'Expired card',
            fraudulent: 'Declined as Stripe suspects it is fraudulent',
            generic_decline: 'Card declined unknown reason (3). Please contact your bank.',
            incorrect_cvc: 'The cvc number is incorrect',
            incorrect_number: 'The card number is incorrect',
            incorrect_zip: 'The ZIP/postal code is incorrect',
            insufficient_funds: 'The card has insufficient funds',
            invalid_account: 'The card, or account the card is connected to, is invalid.',
            invalid_amount: 'The payment amount is invalid, or exceeds the amount that is allowed',
            invalid_cvc: 'The CVC number is incorrect',
            invalid_expiry_month: 'Invalid expiry month',
            invalid_expiry_year: 'The expiration year invalid',
            invalid_number: 'The card number is incorrect',
            issuer_not_available: 'The card issuer could not be reached',
            lost_card: 'Card is reported lost',
            missing: 'There is no card linked',
            new_account_information_available: 'The card, or account the card is connected to, is invalid',
            no_action_taken: 'Card declined unknown reason (4). Please contact your bank.',
            not_permitted: 'The payment is not permitted',
            payment_method_provider_decline: 'Payment method provider decline',
            pickup_card:
              'The card cannot be used to make this payment (it is possible it has been reported lost or stolen)',
            pin_try_exceeded: 'The allowable number of PIN tries has been exceeded',
            processing_error: 'An error occurred while processing the card',
            reenter_transaction: 'The payment could not be processed by the issuer for an unknown reason',
            resource_missing: 'Default Credit Card missing, please add a valid Credit Card first',
            restricted_card:
              'The card cannot be used to make this payment (it is possible it has been reported lost or stolen)',
            revocation_of_all_authorizations: 'Card declined unknown reason (5). Please contact your bank.',
            revocation_of_authorization: 'Card declined unknown reason (6). Please contact your bank.',
            security_violation: 'Card declined unknown reason (7). Please contact your bank.',
            service_not_allowed: 'Service not allowed',
            stolen_card: 'Card is reported stolen',
            stop_payment_order: 'Card declined unknown reason (8). Please contact your bank.',
            testmode_decline: 'A Stripe test card number was used',
            transaction_not_allowed: 'Card declined unknown reason (9). Please contact your bank.',
            try_again_later: 'Card declined unknown reason (10). Retry again later.',
            withdrawal_count_limit_exceeded:
              'The customer has exceeded the balance or credit limit available on their card'
          },
          fraudulent: 'Fraudulent',
          highest: 'Highest',
          invalid: 'Invalid',
          issuer_declined: 'Issuer declined',
          manual_review: 'Manual review',
          network_status: 'Network status',
          normal: 'Normal',
          not_assessed: 'Not assessed',
          not_sent_to_network: 'Not send to Network',
          receipt_number: 'Receipt number',
          reversed_after_approval: 'Reversed after approval',
          risk_level: 'Risk level',
          type: 'Charge type'
        }
      },
      trial_due: 'Expiration of free days',
      trial_expiration_date:
        'Your credit card will be charged on the {{trial_expiration_date}} date your trial period ends.',
      trial_used: 'Free period ended',
      unpaid_message:
        'We would like to inform you that as today your license is EXPIRED. Please check if you have sufficient funds or if you need authorization from your bank to avoid blocking subscription.',
      you_have_basic_trial: {
        one: 'You have {{days}} day of trial!',
        other: 'You have {{days}} days of trial!'
      },
      your_trial_period_ends_today: 'Your trial period ends today'
    },
    dashboard: {
      alerted: 'Alerted',
      clients_chart_info: 'Here you can see the history of clients (Created / Deleted)',
      contract_states_changes: 'Contract states changes',
      contracts_chart_info: 'Here you can see the history of contracts (Created / Deleted)',
      contracts_connected: 'Contracts connected',
      contracts_connected_chart_info: 'Here you can see connected / disconnected contracts',
      contracts_that_are_not_invoiced_when_disabled: 'Contracts that are not invoiced when disabled',
      contracts_with_invoicing_enabled: 'Contracts with invoicing enabled',
      created_current_month: 'Created',
      degraded: 'Degraded',
      help_desk_issues: 'Issues',
      installation_order_chart_info:
        'Here you can see the history of Installation Orders (Created / Approved / Rejected)',
      is_load: 'There are not records to show',
      payments_by_kind: 'Payments by kind',
      periodic_invoices: 'Service invoices',
      periodic_invoices_to_generate: 'Service Invoices to generate',
      still_open: 'Open',
      tooltips: {
        export: 'Export',
        zoom_in: 'Zoom In',
        zoom_out: 'Zoom Out',
        zoom_panning: 'Panning',
        zoom_reset: 'Reset Zoom',
        zoom_selected: 'Selection Zoom'
      },
      total_invoices_draft: 'Total invoices in draft',
      total_invoices_generated: 'Total invoices generated',
      total_invoices_issued: 'Total invoices issued',
      total_periodic_invoices_not_issued: 'Total periodic invoices not issued',
      until_now: 'Until now',
      with_invoice_generation_error: 'Contracts with invoice error generation'
    },
    default: {
      is_load: 'There are no records to show',
      no_record: 'There are no {{model}} to show',
      no_record_cta_create_female: 'Create ',
      no_record_cta_create_male: 'Create ',
      no_record_cta_create_other: 'Create ',
      no_templates_available: 'No {{model}} Templates are available',
      only_first_search: 'Make your first search to get started',
      record_not_found: 'Record not found',
      titleErrors: 'Please review the problems below:'
    },
    dhcp_server: {
      loading_server_information: 'Loading server information...',
      no_server_data_found: 'No server data found',
      loading_leases: 'Loading leases...',
      leases: 'Leases',
      lease_no_records: 'There are no Leases to show'
    },
    discount: {
      create_discount: 'Create discount',
      search_by_name: 'Search by discount name',
      not_expiring: 'Not expiring',
      starts_at: 'If not specified, will be available immediately.',
      expires_at: 'If not specified, will not expire automatically.',
      validity: 'Validity',
      labels: {
        basic_information: 'Basic information',
        validity: 'Validity',
        invoicing_configuration: 'Invoicing configuration',
        contract_discount_edition_enabled: 'Enable period editing when assigning discount'
      }
    },
    dropzone: {
      dropzone_text_bold: 'drag an image',
      max_size: 'Maximum {{max_size}}Mb'
    },
    document: {
      alert_info:
        '<p>What can you do here?</p><p>In this section you can manage the PDF templates of the <b>Communications Regulation Commission (CRC)</b>.</p><p>Available functions:</p><ul><li>✅ Upload your company logo</li><li>✅ Remove the current logo</li><li>✅ Preview how the final PDF will look</li></ul><p>📋 Instructions for use</p><p>Step 1: Configure the template</p><ul><li>Go to the <b>Orders</b> view</li><li>Select <b>Configure orders</b></li><li>In <b>Configuration type</b>, choose <b>“Installation”</b></li></ul><p>Step 2: Select template</p><p>Edit and choose one of these preview options:</p><ul><li><b>CRC Template</b> - Standard template</li><li><b>Wispro Template</b> - Custom template</li></ul><p>Step 3: Upload your logo (optional)</p><ul><li>Use the <b>“Upload Image”</b> button below</li><li>Accepted formats: <b>JPG, PNG</b></li><li>Maximum size: <b>10MB</b></li><li>Recommended: Images with transparent background for best results</li></ul><p>🔮 Coming soon</p><p>In future versions, you will be able to create and edit templates, which will then be available in the <b>Orders</b> configuration, where you can choose which template to use for each type of document.</p>',
      preview_pdf: 'Preview PDF',
      preview_title: 'Here you will be able to see the PDF once it is generated.',
      reload_pdf: 'Reload PDF',
      blocks: {
        available_blocks: 'Available blocks',
        blocks: 'Blocks',
        content: 'Content',
        create_block: 'Create block',
        edit_block: 'Edit block',
        error_getting_blocks: 'Error getting blocks',
        start_typing_here: 'Start typing here...',
        substitutions: {
          client_email: 'Client E-mail',
          client_name: 'Client name',
          client_national_identification_number: 'National identifier number',
          client_phone: 'Client phone',
          contract_full_address: 'Contract full address',
          contract_number: 'Contract number',
          error_getting_substitutions: 'Erro getting substitutions'
        },
        view_blocks_empty_description: 'Start by creating the ones you need from this section.',
        view_blocks_empty_title: 'No blocks created yet!'
      },
      template: {
        columns: 'Number of columns',
        create_template: 'Create template',
        edit_template: 'Edit template',
        error_getting_templates: 'Error getting templates',
        font_size_body: 'Content font',
        font_size_footer: 'Footer font',
        font_size_title: 'Title font',
        page_format: 'Page format',
        select_template: 'Select template',
        template: 'Template',
        template_blocks: 'Template blocks',
        view_template_blocks_empty_description: 'Create the ones you need from the Blocks section.',
        view_template_blocks_empty_title: 'No blocks available yet!',
        view_template_blocks_add:
          "It doesn't have any blocks yet, but you can add the ones you need from the available section.",
        view_template_ready: 'Your template is ready to go!'
      },
      view_needs_bigger_screen: 'Template management requires a larger screen.',
      view_needs_bigger_screen_hint:
        'We are working to offer support on mobile devices. Meanwhile, please use a larger screen.'
    },
    employee: {
      unlocked_successfully: 'Employee successfully unlocked',
      unlocked_at_header_tooltip:
        'Indicates the date and time the account was locked out due to multiple failed login attempts.',
      blank_table: 'There are no employees yet',
      blank_zones: 'Has no zones yet',
      contact: 'Contact',
      create_employee: 'Create employee',
      created_succesful: 'Employee created',
      delete_employee: 'Delete employee',
      deleted_succesful: 'Employee deleted',
      edit_password: 'Edit password',
      employee_detail: 'Employee detail',
      password_changed: 'Password updated',
      employee_desactivated: 'Employee desactivated',
      roles: 'Roles',
      password: {
        the_password_must_have: 'The password must have:',
        at_least_8_characters: 'At least 8 characters',
        one_uppercase_letter: 'At least one uppercase letter (A-Z)',
        one_lowercase_letter: 'At least one lowercase letter (a-z)',
        one_numer: 'At least one number (0-9)',
        one_special_character: 'At least one special character (ex. !@#$%^&*)'
      },
      password_expired: 'Password expired',
      tooltip: {
        deactivate: 'Disable login',
        activate: 'Enable login'
      },
      searcher: {
        basic_placeholder: 'You can search by: Name, User email, Phone number, Mobile phone number.'
      },
      filter_with_expired_password: 'With expired password',
      update_employee: 'Update employee',
      update_succesful: 'Employee updated',
      zones: 'Zones'
    },
    fiber_configuration: {
      default_feasibility_distance_to_nap: 'NAPs default feasibility distance (in meters)',
      default_feasibility_distance_to_nap_hint: 'Maximum feasible distance, in meters, to connect the ONU to the NAP.',
      fiber_configuration_plans: 'OLTs default available plans'
    },
    gps_point: {
      convert_dms_latitude_coord_to_dd_error: `Valid format for conversion e.g.: 00°00'00"N - 00°00'00"S.`,
      convert_dms_latitude_coord_to_dd_format:
        'Convert latitude in DMS to DD. \nFormat. e.g: 00°00\'00"N - 00°00\'00"S',
      convert_dms_longitude_coord_to_dd_error:
        'You must enter a longitude in valid DMS format. \ne.g: 00°00\'00"E - 00°00\'00"W',
      convert_dms_longitude_coord_to_dd_format:
        'Convert longitude in DMS to DD. \nFormat. e.g: 00°00\' 00"E - 00°00\'00"W ',
      coordinates_conversion_guide: `Convert geographic coordinates to valid map format. Input degrees (°), minutes ('), seconds ("), followed by cardinal direction (N, S, E, W).`,
      coordinates_conversion_guide_example: `45°45'45"S converts to -45.7625.`,
      coordinates_conversion_guide_limit: `Latitude: +90 to -90, Longitude: +180 to -180.`
    },
    helpDesk: {
      issues: {
        print_with_comments: 'Print with comments'
      }
    },
    forwarded_port: {
      without_address_ip: 'WITHOUT ADDRESS IP',
      public_destiny: 'Public Destiny',
      private_destiny: 'Private Destiny',
      tcp: 'tcp',
      udp: 'udp'
    },
    help_desk: {
      issue: {
        assign_contract_to_issue: 'Assign contract to issue',
        click_here_to_try_again: 'Click here to try again',
        client_contracts: 'Client contracts',
        client_contracts_other: 'Other client contracts',
        client_deleted: 'Client deleted',
        client_does_not_have_email: 'Client does not have an email',
        client_has_no_contracts: 'There are no contracts to show',
        client_has_no_devices: 'There are no devices to show',
        client_has_no_invoices: 'There are no invoices to show',
        client_has_no_payment_gateways: 'There are no payment gateways to show',
        client_has_no_payments: 'There are no payments to show',
        client_has_no_tickets: 'There are no issues to show',
        client_invoices: 'Client invoices',
        close_ticket: 'Close Issue',
        close_ticket_comment: 'Close issue comment',
        contract_assigned_to_issue: 'Contract assigned to issue',
        contract_assigned_successfully: 'Contract assigned successfully',
        contract_has_no_articles: 'There are no articles to show',
        contract_has_no_discounts: 'There are no discounts to show',
        contract_has_no_invoices: 'There are no invoices to show',
        contract_has_no_recurring_items: 'There are no recurring items to show',
        contract_has_no_tickets: 'There are no tickets to show',
        contract_invoices: 'Contract invoices',
        contract_price: 'Contract price',
        create_payment: 'Create payment',
        download: 'Download',
        email_invalid: 'The client email is invalid. Please check the email address.',
        email_sent_to: 'Email sent to {{email}}',
        error_fetching_client_information: 'An error occurred while fetching client information',
        error_fetching_comments: 'An error occurred while fetching comments',
        error_fetching_contract_information: 'An error occurred while fetching contract information',
        error_fetching_images: 'An error occurred while fetching images',
        error_fetching_invoicing_information: 'An error occurred while fetching invoicing information',
        error_fetching_network_information: 'An error occurred while fetching network information',
        error_fetching_pppoe_status: 'An error occurred while fetching PPPoE status',
        error_sending_email_contact_support: 'An error occurred while sending the email. Please contact support.',
        error_updating_ticket: 'An error occurred while updating the ticket.',
        finalize_ticket: 'Finalize Issue',
        invoices_and_payments: 'Payments and Invoices',
        invoicing_client: 'Invoicing client',
        invoicing_client_information: 'Invoicing client information',
        invoicing_contract: 'Invoicing contract',
        invoicing_contract_information: 'Invoicing contract information',
        invoicing_information: 'Invoicing information',
        issue_contract: 'Issue contract',
        network_information: 'Network information',
        no_contracts_to_show: 'There are no contracts to show',
        one_month: 'Last month',
        one_week: 'Last week',
        one_year: 'Last year',
        plan_price: 'Plan price',
        remove_employee: 'Remove employee',
        reopen_ticket: 'Reopen Issue',
        select_contract: 'Select contract',
        send_mobile_app_link: 'Send Alerta Internet link by email',
        show_ont_alerts: 'Show ONU alerts',
        show_olt_alerts: 'Show OLT alerts',
        six_months: 'Last 6 months',
        three_months: 'Last 3 months',
        ticket_has_no_comments: 'There are no comments to show',
        ticket_has_no_images: 'There are no images to show',
        unexpected_error_assigning_contract: 'Unexpected error assigning contract',
        unexpected_error_getting_data: 'Unexpected error getting ticket',
        upload: 'Upload',
        view_billing_transactions: 'View billing transactions'
      },
      issues: {
        change_issue_complexity: 'Change issue complexity',
        change_issue_state: 'Change issue state',
        change_issue_priority: 'Change issue priority',
        create_new_issue: 'Create new Issue',
        client_last_issues: "Client's last issues",
        dashboard: {
          assigned: 'Assigned',
          by_assignable: 'By employees',
          by_category: 'By category',
          from: 'From',
          high_complexity_first_letter: 'H',
          historic: 'Historic',
          low_complexity_first_letter: 'L',
          medium_complexity_first_letter: 'M',
          resolution_time: 'Resolution time',
          to: 'To',
          total_due: 'Total Due',
          total_resolved: 'Total Resolved',
          total_pending: 'Total Pending',
          total_unassigned: 'Total Unasigned',
          unresolved: 'Unresolved'
        },
        deleted_client: 'Deleted client',
        dropzone_text: 'Drop images here to upload',
        error_getting_client_contracts: 'Unexpected error getting client contracts',
        error_loading_image: 'Error loading image',
        images_uploaded_successfully: 'Images uploaded successfully',
        notification_mail_closed_issue_disabled:
          'You have the "Close Ticket" notification <1>disabled</1>. Therefore, this comment will not be mailed to the client.',
        notification_mail_closed_issue_enabled:
          'You have the "Close Ticket" notification <1>enabled</1>. Therefore, this comment will be mailed to the customer.',
        minimum_number_of_copies: 'Must print at least 1 copy',
        no_images_to_preview: 'There are no images to preview',
        number_of_copies: 'Nº of copies',
        print_with_comments: 'Print with comments',
        public_description: 'Visible to clients from the mobile app',
        refresh_dashboard_on_search: 'Refresh dashboard on search',
        search_by_clients_name: 'Search by client name',
        searcher: {
          basic_placeholder: 'You can search by: Title, Category, Client, Assignable'
        },
        select_an_issue: 'Must select at least 1 issue',
        select_category: 'Select category',
        set_due_date: 'Set due date',
        show_closed_issues: 'Show closed issues',
        show_issue_details: 'Show ticket details',
        upload_images: 'Upload Images'
      },
      issue_categories: {
        create_new_issue_category: 'Create new category',
        edit_issue_category: 'Edit category'
      }
    },
    hola_suite: {
      card: {
        tooltip: {
          contract: {
            meta: {
              main: {
                state: 'Contract state'
              }
            }
          },
          invoice: {
            meta: {
              main: {
                invoice_amount: 'Invoice amount'
              }
            }
          },
          order: {
            header: {
              status: 'Order type'
            },
            meta: {
              main: {
                state: 'Order status'
              }
            }
          },
          payment: {
            meta: {
              main: {
                payment_amount: 'Payment amount'
              }
            }
          },
          prospect: {
            meta: {
              main: {
                state: 'Prospect state'
              }
            }
          }
        }
      },
      unavailable: {
        banner: {
          inactive: {
            button: {
              text: { inactive: 'I want ¡Hola! Suite', verifying: 'Support ¡Hola! Suite', not_alive: 'Go to Invoices' }
            },
            text: 'Request ¡Hola! Suite integration from your sales representative and manage messages from WhatsApp, Instagram, and more.'
          },
          not_alive: {
            button: {},
            text: "Your account has pending payments. Once you make the payment, you'll be able to access it again and continue your services without interruption."
          },
          verifying: {
            text: "Soon you'll be able to access ¡Hola! Suite and communicate with your customers with personalized service flows."
          }
        },
        title: {
          inactive: 'Your service platform',
          not_alive: 'The service requires a paid upgrade',
          verifying: 'Verification in progress'
        }
      },
      automatic_settings: {
        error_message: {
          already_attended: 'This contact is already being attended',
          blank_destination_number: 'The phone number is blank',
          channel_not_found: 'Channel not found',
          communication_channel_is_invalid: 'The channel is invalid',
          different_number_of_variables: ' Different number of variables than expected',
          invalid_destination_number: 'Phone number is not valid. ',
          invalid_parameter: "This number cann't be notified",
          parameter_missing: 'The required parameters could not be found',
          something_went_wrong: 'Something went wrong',
          template_not_found: 'Template not found',
          unexpected_number_of_params: 'Number of parameters is different than expected',
          unknown_error: 'An error occurred while contacting'
        },
        tour_steps: {
          quick_search_description:
            'Instantly filter your Notifications, forget about endless scrolling. This new quick search makes your daily queries ultra-fast.',
          advanced_search_description:
            'Create complex queries in seconds with our enhanced filter panel. Combine multiple fields and operators to find exactly what you need.',

          configure: {
            title: 'View notifications',
            descriptions: 'Clicking here opens a list of all available automatic notifications.'
          },
          config_table: {
            title: 'Your notifications',
            descriptions: 'Here you see the complete list of all your automatic notification rules.'
          },
          config_button: {
            title: 'Save changes',
            descriptions: 'Click this button to save the settings you just defined.'
          },
          activate_button: {
            title: 'Activate sending',
            descriptions: 'With this switch you activate or deactivate the notification sending.'
          },
          table: {
            title: 'Notification list',
            descriptions: 'Consult here all the automatic notifications you have created.'
          }
        },
        action_column_tooltip: {
          activate_description: 'Use this button to activate or deactivate the automatic sending of notifications.',
          activate_description_activate: 'notifications will be sent automatically to the configured channel.',
          activate_description_inactive:
            'sending will be disabled and you will only be able to send notifications manually',
          activate_title: 'Manage automatic notifications',
          config_channel_template_description: 'Select a template, then click Save to save your configuration.',
          config_template_title: 'Configure Template'
        },
        kind: {
          contract_alerted: 'Contract alerted',
          contract_dgo_pack_discontinued: 'Pack will be discontinued',
          contract_dgo_price_update: 'DGO price update',
          contract_dgo_subscription_created: 'DGO subscription created',
          contract_disabled: 'Contract disabled',
          issue_finalized: 'Help desk issue finalized',
          invoice_first_due_date: 'Invoice first due date',
          invoice_issued: 'Invoice issued',
          invoice_second_due_date: 'Invoice second due date',
          issue: 'Ticket help desk',
          manual: 'Manual',
          order_feasibility_failure: 'Feasibility analysis failed',
          order_feasibility_success: 'Feasibility analysis successful',
          order_installation_failure: 'Installation visit failed',
          order_installation_scheduled: 'Installation visit scheduled',
          order_installation_success: 'Installation visit successful',
          order_resignation_failure: 'Cancellation visit failed',
          order_resignation_scheduled: 'Cancellation visit scheduled',
          order_resignation_success: 'Cancellation visit successful',
          order_technical_failure: 'Technical visit failed',
          order_technical_scheduled: 'Technical visit scheduled',
          order_technical_success: 'Technical visit successful',
          payment_created: 'Payment created',
          ticket: 'Ticket sales table'
        }
      },
      templates: {
        tour_steps: {
          quick_search_description:
            'Instantly filter your Templates—no more endless scrolling. This new quick search makes your daily queries lightning-fast.',
          advanced_search_description:
            'Build complex queries in seconds with our enhanced filter panel. Combine multiple fields and operators to find exactly what you need.',
          create: {
            title: 'Create new template',
            descriptions:
              'Click here to open the form where you can create a new notification template. From this interface you will be able to define all the details to automate your messages.'
          },
          name_input: {
            title: 'Template name',
            descriptions:
              'This field defines the internal name of your template. It will help you to easily identify it when you need to edit or reuse it.'
          },
          kind_input: {
            title: 'Module you are sending from',
            descriptions:
              'Here you select the module of the platform to which the template will be applied: contracts, customers, orders, payments, etc. It is very important to choose this scope correctly so that the message is sent in the right context.'
          },
          template_input: {
            title: 'Choose the message',
            descriptions:
              'Choose the predefined Hello Suite message that will be sent automatically. Some templates include substitutions: these are keywords that are dynamically replaced based on the context of the message. If the template you select has substitutions, you will need to fill them in to customize your notification.'
          },
          channel_input: {
            title: 'Send channel',
            descriptions:
              'Select the channel through which the notification will be sent, such as WhatsApp, Telegram or other available channel. Configure this channel correctly to ensure your customers receive the message where it belongs.'
          },
          submit_input: {
            title: 'Save settings',
            descriptions:
              'Click here to save and activate the template with all the configured data. Make sure you have filled in each field correctly before continuing.'
          },
          table: {
            title: 'Configured templates',
            descriptions:
              'Here you will see all the templates you have already created. For each one you can check its name, the channel through which it will be sent, the message that will be used and where it will be sent from. In addition, you have shortcuts to edit or manage them whenever you need to.'
          },
          table_edit: {
            title: 'Edit template',
            descriptions:
              'By clicking here you can open the configuration of this template to modify its fields. It is useful if you need to change the message, the channel or adjust any details of the notification.'
          }
        },
        substitutions: {
          contract: 'Contract',
          invoice: 'Invoice',
          lead: 'Lead',
          order: 'Order',
          payment: 'Payment',
          prospect: 'Prospect',
          foo: 'Foo',
          algo: 'Algo',
          sequential_id: 'ID',
          plan_name: 'Plan name',
          first_due_date: 'First due date',
          second_due_date: 'Second due date',
          invoice_issued: 'Invoice',
          issued_at_day: 'Issued at',
          contract_disabled: 'Contract disabled',
          payment_created: 'Payment created',
          order_feasibility_approved: 'Feasibility analysis successful',
          order_feasibility_not_approved: 'Feasibility analysis failed',
          order_installation_scheduled: 'Installation visit scheduled',
          order_installation_completed: 'Installation visit successful',
          order_installation_failed: 'Installation visit failed',
          order_technical_scheduled: 'Scheduled technical visit',
          order_technical_completed: 'Successful technical visit',
          order_technichal_failed: 'Failed technical visit',
          order_cancellation_scheduled: 'Scheduled deregistration visit',
          order_cancellation_completed: 'Discontinuation visit successful',
          order_cancellation_failed: 'Discontinuation visit failed',
          contract_dgo_subscription_created: 'DGO subscription created',
          contract_dgo_price_update: 'DGO price update',
          contract_dgo_pack_discontinued: 'Pack to be discontinued',
          payment_date_day: 'Payment date',
          employee_name: 'Assigned employee name',
          start_at_date: 'Start date',
          start_at_time: 'Start time'
        },
        template_hola: {
          one: 'Template Hola'
        },
        one: 'Template',
        other: 'Templates'
      },
      manual_settings: {
        notification_status: 'Notification status',
        hints: {
          created_at:
            'Manual notifications are now grouped solely by their sending time, simplifying viewing and making it easier to filter logs.'
        }
      }
    },
    horizontal_async_select: {
      enter_search: 'Please enter your search',
      error_getting_option: 'Unexpected error getting options',
      no_search: 'No results found',
      search: 'Searching...',
      type_characters_to_search: 'Type {{count}} or more characters to search'
    },
    installation_order_configuration: {
      agreement_details: 'Field to detail the terms of use or disclaimers to show on the PDF'
    },
    invoicing_contract: {
      alerted_date_by_system: 'Alerted automatically at',
      cancel_initial_invoice: 'Cancel initial invoice',
      current_period_invoiced: 'Current period invoiced',
      description_for_initial_invoice_warning:
        'The system will automatically invoice the next period on {{from}}. You can generate an initial service invoice with the following button.',
      disabled_date_by_system: 'Disable automatically at',
      from_to: 'The system will automatically invoice the contract on the day {{from}} to {{to}}',
      generate_initial_invoice: 'Generate initial invoice',
      generate_service_invoice: 'Generate service invoice',
      info_autocalculate_amount:
        'Changing the start or end date to be invoiced, the system will calculate the amount based on the plan price. You can change this amount.',
      initial_invoice_generated: 'Initial invoice generated.',
      initial_invoice_not_generated: 'The initial invoice has not been generated.',
      invoicing_disabled: 'Invoicing disabled',
      plan_amount: 'Plan price: {{amount}}',
      profile: 'Invoicing Profile',
      next_period_to_invoice: 'Next period to invoice'
    },
    invoicing_firm: {
      configuration: 'Configuration',
      create_new_invoicing_firm: 'Create Invoicing Firm',
      no_preview_numeration: 'No previous numbering to display'
    },
    invoicing_configuration: {
      show_invoicing_firms: 'Show Invoicing firms',
      without_invoicing_firms: 'Without Invoicing firms'
    },
    invoicing_profile: {
      alert_after_days: 'Will be <1>alert</1> contracts after {{days}} days since first due date',
      alert_on_first_due_date: 'Will be <1>alert</1> contracts on first due date',
      amount: '<0>Amount:</0> {{amount}}',
      basic: 'Basic',
      days_before_end_period: '{{days}} days before the end of period',
      disable_after_days: 'Will be <1>disable</1> contracts after {{days}} days since second due date',
      disable_on_second_due_date: 'Will be <1>disable</1> contracts on second due date',
      disabled: 'Disabled',
      due_at: 'Due at <1>{{due_days}} days</1> since <3>{{period}}</3>',
      due_at_end_of_period: 'Due <1>{{period}}</1>',
      enabled: 'Enabled',
      end_of_period: 'at the end of each period',
      first_due: '1st Due',
      invoicing_generation: 'Invoicing generation',
      never_alert: 'Never <1>alert</1> contracts',
      never_disable: 'Never <1>disable</1> contracts',
      second_due: '2nd Due',
      since_beginning_of_period: 'beginning of period',
      since_end_of_period: 'end of period',
      tax_reconnection: '<0>Tax:</0> % {{rate}}',
      when_generate: {
        beginning_of_period: 'At the beginning of the period',
        days_before_end: 'Select days before the end of period',
        end_of_period: 'At the end of the period'
      },
      without_interest: 'Without the interest',
      with_interest_mount: '<0>The interest will be</0> {{amount}}',
      with_interest_percentage: '<0>The interest will be</0> % {{amount}}',
      without_tax: 'Without Tax'
    },
    invoicing: {
      cash_audit: {
        searcher: {
          basic_placeholder_index: 'You can search by: ID and Creator name',
          basic_placeholder_show: 'You can search by: Client, Collected by, Registered by and Transaction kind',
          current_month: 'Current Month',
          last_three_months: 'Last 3 Months'
        },
        confirmation_modal_body: 'A cash audit will be created with the following data:',
        create_cash_audit: 'Create Cash Audit',
        create_new_cash_audit: 'Create new Cash Audit',
        error_create_cash_audit: 'Error creating cash audit',
        success_create_cash_audit: 'Cash audit created successfully',
        dashboard: {
          current_month_cash_audits_count: 'Cash Audits Conducted This Month',
          current_month_cash_audits_amount: 'Total Audited This Month',
          not_validated: 'Not Validated',
          not_validated_payments_count: 'Unverified Payments',
          not_validated_payments_amount: 'Unverified Total Amount',
          selected: 'Selected',
          selected_payments: 'Selected Payments',
          selected_payments_amount: 'Selected Total Amount',
          transactions_by_amount: 'Total amount by transaction kind',
          transactions_by_count: 'Quantity by transaction kind'
        },
        export: {
          select_format: 'Select the format you want to export to',
          bulk_actions_successful: 'You will recive an email with the results',
          export_error: 'Error in export'
        },
        payments_quantity: 'Payments Quantity',
        total_amount: 'Total amount'
      },
      dolarizer: {
        change_exchange_values: 'To change this value, you can do it from ',
        exchange_currency: 'Exchange currency',
        invoicing_currency: 'Current currency',
        invoicing_currency_to_exchange_currency_rate: 'Exchange rate',
        set_exchange_currency: 'To set the Exchange Rate, you must first set the exchange currency from '
      },
      client: {
        hints: {
          colombia: {
            taxpayer_identification_number:
              'For billing with (Siigo), the verification digit must be separated by - or /, while for (HKA), the verification digit is not separated.'
          },
          mexico: {
            invoicing_name: 'Declared in SAT',
            taxpayer_identification_number: 'RFC is mandatory if you didnt choose Fantasy',
            zip_code: 'Zip code declared in SAT'
          },
          peru: {
            invoicing_name: 'Declared in SUNAT',
            taxpayer_identification_number: 'The RUC is mandatory if it is a legal entity or chooses a sales invoice.'
          }
        }
      },
      contract_discount: {
        successfully_canceled: 'Successfully canceled',
        successfully_deleted: 'Successfully deleted'
      },
      invoice: {
        export: {
          bancolombia_all_invoices: 'Bancolombia (All)',
          bancolombia_format: 'Bancolombia Format',
          bancolombia_selected_invoices: 'Bancolombia ({{selected_count}} selected)',
          efecty_all_invoices: 'Efecty (All)',
          efecty_format: 'Efecty Format',
          efecty_selected_invoices: 'Efecty ({{selected_count}} selected)',
          export_debt: 'Export debt',
          export: 'Export',
          exporting: 'Exporting...',
          loading_payment_gateways: 'Loading payment gateways...',
          no_payment_gateways: 'No payment gateways configured for this format',
          payment_gateway_required: 'Select a payment gateway to use this format',
          payment_gateway_required_for_bancolombia: 'Select a payment gateway to use Bancolombia format',
          prisma_all_invoices: 'Prisma (All)',
          prisma_format: 'Prisma Format',
          prisma_selected_invoices: 'Prisma ({{selected_count}} selected)',
          select_invoices_hint: 'If you want a more accurate selection, mark them in the table',
          selected_invoices: 'Selected invoices'
        },
        without_first_due_date: 'Without 1st due date',
        without_second_due_date: 'Without 2nd due date'
      },
      issued_invoices: {
        void: 'Void',
        amount_to_void: 'Amount to voided'
      },
      payment_gateways: {
        there_are_no_verified_gateways_to_associate: 'There are no verified gateways to associate.'
      },
      payment_receipts: {
        create_payment: 'Create payment',
        change_to_processed: 'Process',
        change_to_pending: 'Return to Pending',
        discard_payment_receipt: 'Discard Payment Receipt',
        error_loading_preview: 'Error while loading the preview',
        searcher: {
          basic_placeholder: 'Client name, invoice number'
        },
        state: {
          communication_error: 'Validating',
          discarded: 'Discarded',
          error: 'Error',
          pending: 'Pending',
          processed: 'Processed',
          processing: 'Processing'
        },
        successfully_updated: 'Successfully updated',
        process_payment_receipt: 'Process Payment Receipt'
      },
      payment_transactions: {
        successfully_unbinded: 'Successfully unbinded',
        no_associated_payments: 'No associated payments'
      },
      profiles: {
        navtabs: {
          tabs: {
            first_due_date: '1st. Due date',
            second_due_date: '2s. Due date',
            alert_contracts_start: 'Strategy to alert contracts',
            disabled_contracts_start: 'Strategy to disabled contracts'
          }
        }
      },
      kind_invoices: {
        argentina_a: 'Argentine (A)',
        argentina_b: 'Argentine (B)',
        argentina_c: 'Argentine (C)',
        colombia: 'Sales invoice',
        credit_note: 'Credit note',
        ecuador: 'Sales invoice',
        espana: 'Spain',
        invoice: 'Invoice',
        mexico: 'Sales invoice',
        peru_final_consumer_invoice: 'Sales final consumer invoice',
        peru_invoice: 'Sales invoice',
        sales_invoice: 'Sales invoice',
        sales_receipt: 'Sales receipt',
        voucher: 'Voucher'
      },
      kind_person: {
        mexico_natural: 'Physic Person',
        mexico_juridic: 'Moral Person'
      },
      vat_condition: {
        juridic_person: 'Legal entity',
        natural_person: 'Natural person',
        billing_regime: 'Billing Regime',
        billing_regime_juridical: 'Billing Regime (Business)',
        billing_regime_person: 'Billing Regime (Person)',
        common_regime: 'Common Regime',
        common_regime_juridical: 'Common Regime (Business)',
        common_regime_person: 'Common Regime (Person)',
        exempt: 'Exempt',
        fantasy: 'Fantasy',
        final_consumer: 'Final consumer',
        registered_vat_payer: 'Registered vat payer',
        self_employed_taxpayer: 'Self employed taxpayer',
        not_applicable: 'Not applicable',
        simplified_regime: 'Simplified Regime',
        general_regime: 'General Regime of Legal Persons Law',
        legal_entities_with_non_profit_purpose: 'Legal Entities With Non Profit Purpose',
        wages_and_salaries_and_income_assimilated_to_salaries: 'Wages And Salaries And Income Assimilated To Salaries',
        lease: 'Lease',
        property_disposal_or_acquisition_regime: 'Property Disposal Or Acquisition Regime',
        other_income: 'Other Income',
        residents_abroad_without_permanent_establishment_in_mexico:
          'Residents Abroad Without Permanent Establishment In Mexico',
        dividend_income: 'Dividend Income',
        individuals_with_business_and_professional_activities: 'Individuals With Business And Professional Activities',
        interest_income: 'Interest Income',
        income_regime_for_obtaining_prizes: 'Income Regime For Obtaining Prizes',
        no_tax_obligations: 'No Tax Obligations',
        production_cooperative_societies_that_choose_to_defer_their_income:
          'Production Cooperative Societies That Choose To Defer Their Income',
        tax_incorporation: 'Tax Incorporation',
        agricultural_livestock_forestry_and_fishing_activities:
          'Agricultural Livestock Forestry And Fishing Activities',
        optional_for_groups_of_companies: 'Optional For Groups Of Companies',
        coordinated: 'Coordinated',
        regime_of_business_activities_with_income_through_technological_platforms:
          'Regime Of Business Activities With Income Through Technological Platforms',
        simplified_trust_regime: 'Simplified Trust Regime'
      }
    },

    invoicing_taxes: {
      kinds: {
        colombia_contrib: 'Contribuciones',
        colombia_ica: 'ICA',
        colombia_ico: 'ICO',
        colombia_ret_hon: 'Retención en la fuente por renta Honorarios',
        colombia_ret_ica: 'Retención en la fuente por ICA',
        colombia_ret_iva: 'Retención en la fuente por IVA',
        colombia_ret_purch: 'Retención en la fuente por renta Compras',
        colombia_ret_serv: 'Retención en la fuente por renta Servicios',
        colombia_ret_transp: 'Retención en la fuente por renta Transporte',
        costa_rica_911: '911',
        costa_rica_cruz_roja: 'Red Cross',
        ecuador_ice: 'ICE',
        iva: 'IVA',
        mexico_ieps: 'IEPS',
        panama_itbms: 'ITBMS',
        peru_igv: 'IGV'
      }
    },
    isps: {
      api_token: {
        regen: 'Regen Token',
        sending: 'Sending',
        title: 'API Authentication Token'
      },
      archive_isp: 'Archive ISP'
    },
    mikrotik: {
      allow_only_allowed_contracts_to_navigate: {
        off: "<0>OFF:</0> Free traffic, accepting any type of traffic. Useful option for <2>MikroTik's</2> that are already working and that do not have contracts loaded in <4>Wispro</4>.",
        on: '<0>ON:</0> Only the allowed contracts can be able to navigate (enabled, alerted, downgraded).'
      },
      cant_connect_to_service_please_refresh_page:
        'Communication error, reload the page and if the error persists, contact support.',
      command_description:
        'Open a terminal on your Mikrotik and copy the following commands to make the VPN connection.',
      commands_for_mikrotik: 'Commands for Mikrotik',
      mikrotik_configuration: 'Mikrotik Configuration',
      mikrotik_use_ssl: 'Certificate is required (Check wispro guides)',
      notification_https_block:
        'In order to redirect HTTPS traffic we need to block it.<1/>The redirection is not inmediate, the original request must wait until a browser timeout is triggered.<3/>Once this timeout is reached the browser request an HTTP page (generate_204) and then shows the notification in a new tab.',
      select_mikrotik_version_label: 'Select Mikrotik version',
      traffic_control_enabled:
        'Disabling bandwidth control will not prioritize or limit customer traffic.<1/>Works on Mikrotik and Bmu versions greater or equal than <3>0.6.4</3>.',
      uniq_contracts_mac_address: 'Check contract MAC address uniqueness',
      vpn_client_configuration: 'VPN client configuration',
      web_proxy_enabled: {
        alert_contracts: 'Alert contracts.',
        customized_notifications: 'Customized notifications.',
        service_disabled: 'Service disabled.',
        title: 'Web proxy is necessary for notifications flow:'
      },
      interfaces: {
        add_address: 'Add address',
        service_kind: 'Service kind'
      },
      unpenalize_wait: 'Processing, please wait.'
    },
    mikrotiks: {
      ping: {
        sent: 'Sent',
        received: 'Received',
        status: 'Status',
        size: 'Size',
        ttl: 'TTL',
        time: 'Time',
        packet_loss: 'Packet Loss %'
      }
    },
    maps: {
      cluster: 'You will be able to deactivate the clusters after zoom 16',
      contract: 'Show/hide contrats',
      warehouse: 'Show/hide warehouses',
      coverage: 'Show/hide coverages',
      fiber: 'Show/hide fiber',
      home: 'Home',
      inputAddressContract: 'To use the filter, enable the map',
      isp: 'Center ISP',
      nap: 'Show/hide NAPs',
      node: 'Show/hide nodes',
      olt: 'Show/hide OLTs',
      ont_signal: 'Show/hide ONUs signal',
      search_by_name: 'Search by name',
      search_contracts_by_ont_signal: 'Search contracts by ONU signal',
      searcher: {
        enums: {
          client: {},
          contract: {
            state: {
              alerted: 'Alerted',
              degraded: 'Degraded',
              disabled: 'Disabled',
              enabled: 'Enabled'
            }
          },
          coverage: {},
          node: {
            kind: {
              fiberbox: 'Fiberbox',
              wireless: 'Wireless'
            }
          }
        },
        kind: 'Kind',
        name: 'Name',
        neighborhood_id: 'Neighborhood',
        node_id: 'Node (ID)',
        sequential_id: 'Sequential ID',
        ssid: 'Name',
        state: 'State',
        brand: 'Brand',
        fbp: 'Interface',
        the_results_will_be_displayed_in_the_visible_area: 'The results will be displayed in the visible area',
        this_model_does_not_have_search_criteria_yet: 'this model does not have search criteria yet.'
      },
      you_must_complete_all_fields: 'You must complete all fields'
    },
    nap: {
      all_nap_contracts_have_seal: "All NAP's contracts have a seal",
      client_input_placeholder: 'search by name',
      contracts_associated_to_nap: 'Contratos asociados a la nap',
      dashboard: {
        alerts: 'Alerts',
        alerts_no_records: 'There are no alerts to show',
        alerts_title: 'Todays critical and major alerts',
        authorized_onts: 'Authorized',
        critical_alarms: 'Critical or Major alarms',
        critical_interfaces: 'Critical interfaces',
        error_querying_olt: 'Error querying OLT',
        interfaces: 'Interfaces',
        interface_signal_warning_tooltip: 'ONUs with critical or warning signal grather than 80%',
        interfaces_no_records: 'There are no Interfaces to show',
        title_hint: 'The data update depends on the response time of each OLT',
        linked_olts: 'Linked OLTs',
        linked_olts_no_records: 'There are no linked OLTs to show',
        linked_onts: 'Linked',
        linked_status: 'Linked status',
        not_authorized: 'Not authorized',
        not_linked_olts: 'Not linked',
        offline_onts: 'Offline',
        olts_queried: 'OLTs queried',
        online_onts: 'Online',
        querying_olt: 'Querying OLT',
        retry: 'Retry',
        retry_olts_with_errors: 'Retry OLTs with errors',
        signal_status: 'Signal status',
        successfull_olt_query: 'Successfull OLT query',
        title: 'ONUs detail',
        tooltip_message_info_naps_broken_slots: 'Broken ports',
        tooltip_message_info_naps_broken_slots_full_message: 'Amount of ports marked as broken',
        tooltip_message_info_naps_capacity_total: 'Total capacity',
        tooltip_message_info_naps_capacity_total_full_message: 'Total number of NAP ports',
        tooltip_message_info_naps_free_slots: 'Available ports',
        tooltip_message_info_naps_free_slots_full_message: 'Total number of available NAP slots',
        tooltip_message_info_naps_onts_linked: 'Filled ports',
        tooltip_message_info_naps_onts_linked_full_message:
          'Result of the sum between the number of contracts associated with the NAP and ports marked as filled without an associated contract'
      },
      enter_port: 'Enter a port',
      fbp: 'Frame/Board/Port',
      feasibility_distance_hint:
        'If no value is entered, feasibility will be determined using the value entered in the Optical Fiber Configuration ({{value}} m).',
      fetch_available_ports_error: 'Error fetching available ports',
      fetch_available_ports_success: 'Search for available ports succesful',
      fetch_available_ports_retry: 'Retry search for available ports',
      hints: {
        must_associate_olt: 'Must associate an OLT',
        nap_full_capacity: 'NAP at full capacity',
        must_assign_a_port_to_the_contracts: 'Must assign a port to the contracts associated to the NAP'
      },
      massive_update_error_detail_message: '{{attr}}: {{error_type}} {{restriction_value}}, {{error_count}}',
      massive_update_error_hint: 'Click on item in the list and filter on table the NAPs with errors',
      massive_update_error_refresh: 'No errors have been found in the massive update.',
      massive_update_error_title: 'Massive Update Errors ({{count}} {{plurality}})',
      massive_update_nap_with_errors: '{{error_count}} affected NAP',
      massive_update_naps_with_errors: '{{error_count}} affected NAPs',
      massive_update_process: 'The massive update is in process.',
      massive_update_remove_all_errors: 'Errors in the massive update have been cleaned up.',
      massive_update_no_naps_selected: 'No NAPs selected.',
      nap_contracts_without_nap_port: 'The NAP has {{contracts}} contracts without an assigned port',
      nap_contracts_without_seal: 'The NAP has {{contracts}} contracts without an assigned seal',
      nap_port_form: {
        unable_to_free_port: 'To release the port you must disassociate the associated contract',
        unable_to_broken_port: 'To mark the port as broken you must disassociate the associated contract',
        change_port_state: 'Change port state'
      },
      nap_ports_state: 'Ports State',
      nap_has_no_contracts: 'The NAP does not have connected contracts',
      port_select_placeholder: 'Find available ports',
      power_limit_hint: 'Reference value to check if the installation of an ONU was successful or if it has problems.',
      reset_to_default_value: 'Reset to default value ({{value}} m)',
      no_available_ports: 'No ports available',
      help_tooltips: {
        availability_header: {
          capacity: {
            title: 'Capacity',
            body: 'Total number of ports available in the NAP.'
          },
          broken_ports: {
            title: 'Broken Ports',
            body: 'Number of ports that cannot be used as they have been marked as broken.'
          }
        },
        nap_port_states_header: {
          broken: {
            title: 'Broken Ports',
            body: 'Number of ports that cannot be used as they have been marked as broken.'
          },
          capacity: {
            title: 'Capacity',
            body: 'Total number of ports available in the NAP.'
          },
          free: {
            title: 'Free Ports',
            body: 'Ports available for assignment.'
          },
          filled_with_contract: {
            title: 'Filled Ports with Contract',
            body: 'Ports that are currently in use and linked to an active contract.'
          },
          filled_without_contract: {
            title: 'Filled Ports without Contract',
            body: 'Ports that are currently in use but do not have an associated contract.'
          }
        },
        seals_header: {
          seals_with_contract: {
            title: 'Seals with Contract',
            body: 'NAP seals that are linked to a contract.'
          },
          seals_without_contract: {
            title: 'Seals without Contract',
            body: 'NAP seals that do not have an associated contract.'
          },
          total: {
            title: 'Total Seals',
            body: 'Total number of seals assigned to the NAP.'
          }
        },
        alerts_header: {
          nap_port_alerts: {
            title: 'NAP Port Alert',
            with_alerts:
              'Contracts without assigned port: Indicates the number of contracts linked to the NAP that do not have an assigned port.',
            without_alerts: 'No alerts: All contracts linked to the NAP have an assigned port.'
          },
          seals_alerts: {
            title: 'Seal Alert',
            with_alerts:
              'Contracts without assigned seal: Indicates the number of contracts linked to the NAP that do not have an assigned seal.',
            without_alerts: 'No alerts: All contracts linked to the NAP have an assigned seal.'
          }
        }
      }
    },

    nas: {
      linked_nas: 'Linked NAS',
      unlinked_nas: 'Unlinked NAS',
      the_nas_service_is_linked_and_the_number_of_linked_nas_is_counted:
        'The NAS service is linked, the number of linked nas is counted',
      the_nas_service_is_unlinked: 'The NAS service is unlinked'
    },
    navigation: {
      topnav: {
        signout: 'Sign Out',
        edit_user: {
          client_input_search_message: 'Type 3 characters to search',
          error_fetching_isp: 'Error while fetching ISPs',
          error_updating_user: 'Error while setting up fake user',
          isp_not_found: 'ISP not found'
        },
        users_guide: 'Users Guide'
      }
    },
    neighborhood: {
      created_succesful: 'Neighborhood created',
      deleted_succesful: 'Neighborhood deleted',
      is_load: 'Neighborhoods not found',
      neighborhoods_title: 'New Neighborhood',
      neighborhoods_title_edit: 'Edit Neighborhood',
      searcher: {
        basic_placeholder: 'You can Search By: Name'
      },
      updated_succesful: 'Neighborhood updated'
    },
    olt_server_interfaces: {
      uplink_port: 'Uplink port OLT',
      basic_placeholder: 'You can search by: OLT Name, Server Name, VLAN Number',
      autodiscover_refresh: 'Autodiscover Refresh',
      autodiscover_success: 'Autodiscover refresh was successful',
      autodiscover_error: 'Autodiscover refresh failed',
      autodiscover: 'Autodiscover refresh',
      pon_port: 'PON Port',
      pon_ports: 'PON Ports',
      parent_interface: 'Parent Interface',
      logic_interface: 'Logic Interface'
    },
    orders: {
      index: {
        add_article: 'Add article',
        bulk_actions: {
          download: {
            hint_1: ' Export may take several minutes; to avoid timeouts, download in batches of maximum 1,000 orders.',
            hint_2: 'Filter your orders before exporting to reduce file size and complexity.',
            hint_3: 'The orders without a contract/prospect will not be exported.',
            hint_4: 'Use CSV for large volumes of data; reserve XLS for advanced functions only.'
          }
        },
        by_order_kind: 'By order kind',
        change_order_state: 'Change order state',
        click_here_to_add_article: 'Click here to add an article',
        click_here_to_restore_contract: 'Click here to restore contract',
        click_here_to_generate_contract: 'Click here to generate contract',
        click_here_to_generate_networking_config: 'Click here to generate the network configuration',
        click_here_to_go_to_contract: 'Click here to go to contract',
        click_to_change_state: 'Click here to change order state',
        completed_orders: 'Completed orders',
        configure_feedback_kinds: 'Configure feedback kinds',
        configure_order_configurations: 'Configure orders PDF',
        configure_order_parameters: 'Configure orders parameters',
        contract_generated: 'Contract generated',
        contract_deleted: 'Contract deleted',
        contract_not_generated: 'Contract not generated',
        create_new_feedback_kind: 'Create new feedback kind',
        create_order: 'Create order',
        create_order_finalized_or_closed: "It's not possible to create an order with a closed or completed ticket.",
        create_order_with_contract: 'To create an order, you must first associate a contract.',
        create_order_without_contract: 'To create an order, it must not be associated with a contract.',
        current_month: 'Current month',
        deleted_contract: 'Deleted contract',
        deleted_employee: 'Deleted employee',
        deleted_prospect: 'Deleted prospect',
        error_getting_dashboard: 'An error occurred while fetching the dashboard',
        error_loading_lead_data: 'Error loading Lead data',
        failure: 'Failed',
        fix_errors: 'Fix errors',
        help_desk_ticket: 'Help Desk Ticket #{{ sequential_id }}',
        historic: 'Historic',
        last_three_months: 'Last 3 months',
        lead_converted_successfully: 'Lead converted successfully',
        lead_conversion_went_wrong: 'Lead conversion went wrong',
        network_configuration: 'Network configuration',
        networking_config_not_generated: 'Network configuration not generated',
        new_order_state: 'New order state',
        no_assigned_employee: 'No assigned employee',
        no_associated_ticket: 'No associated ticket',
        select_employee: 'Select employee',
        click_to_assign_employee: 'Click to assign employee',
        click_to_change_employee: 'Click to change employee',
        no_images_to_preview: 'There are no images to preview',
        not_scheduled: 'Not scheduled',
        order_kind: 'Order kind',
        overdue_orders: 'Overdue orders',
        pdf: {
          contract_required: 'The PDF is only available when the order has a contract.'
        },
        preparing_contract_generation: 'Preparing contract generation...',
        prospect_already_convert: 'The prospect already has a generated contract',
        removed_article_destination: 'Removed article destination',
        reschedule: 'Reschedule',
        restore_contract: 'Restore contract',
        sale_desk_ticket: 'Sale Desk Ticket #{{ sequential_id }}',
        schedule: 'Schedule',
        scheduled: 'Scheduled',
        success: 'Success',
        time_period: 'Time period',
        to_reschedule_orders: 'Orders to reschedule',
        unscheduled: 'Unscheduled',
        update_feedback_kind: 'Update feedback kind',
        update_ticket_badges: 'Update ticket #{{sequential_id}} badges'
      },
      schedule: {
        cant_reschedule_completed_order: 'You can not reschedule a completed order',
        drag_order: 'Drag an Order and drop it into calendar',
        end_at_input_hint: 'To change the start and end date, drag the event on the calendar.',
        no_orders_to_schedule: 'There are no orders to schedule',
        no_available_employees:
          'There are no employees with installer, installer supervisor, technician or technician supervisor roles',
        not_scheduled: 'Not scheduled',
        non_scheduled_orders: 'Non scheduled orders',
        one_day: '1 day',
        reschedule: 'Reschedule',
        schedule: 'Schedule',
        scheduled_orders: 'Scheduled orders',
        select_a_not_scheduled_order: 'Select a non scheduled order',
        three_days: '3 days',
        unexpected_error_getting_orders: 'Unexpected error getting orders',
        view_needs_bigger_screen: 'Order scheduling needs a larger screen',
        view_needs_bigger_screen_hint:
          'We are working to offer support on mobile devices. Meanwhile, please use a larger screen.'
      },
      parameters: {
        sections: {
          orders: 'Orders',
          employees: 'Employees',
          wispro_app: 'Wispro App'
        },
        rules: {
          create_installation_when_finalize_feasibility: 'Create Installation when finalizing Feasibility',
          edit_order_when_finalize: 'Allow edits on finalized Orders',
          close_order_when_finalize: 'Automatically close the Order after finalization',
          create_client_when_create_order: 'Convert Lead into Client when creating the Installation',
          employee_can_autoassign_orders: 'Authorize installer to self-assign an Order',
          employee_can_schedule_orders: 'Authorize installer to schedule an Order',
          same_employee_feasibility_to_installation:
            'Assign the installer who performed Feasibility to the Installation',
          article_management_required_mobile: 'Require item verification',
          track_employees_mobile: 'Require location permissions',
          photos_required_mobile: 'Require photos',
          number_photos_required_mobile: 'Number of photos',
          tracking_level_mobile: 'Tracking requirement level'
        },
        hints: {
          create_installation_when_finalize_feasibility:
            'The Installation Order is automatically created when the Feasibility Order is finalized.',
          edit_order_when_finalize: 'Editing of already finalized Orders is enabled.',
          close_order_when_finalize: 'The Order is automatically closed once it reaches the "Finalized" status.',
          create_client_when_create_order: 'The Lead is converted into a Client when creating the Installation Order.',
          employee_can_autoassign_orders:
            'The installer is authorized to assign themselves as responsible for an available Order.',
          employee_can_schedule_orders:
            'The installer is authorized to choose a date and time to carry out their Orders (depending on availability).',
          same_employee_feasibility_to_installation:
            'The same installer who carried out the Feasibility Order will automatically be assigned to the Installation Order.',
          article_management_required_mobile:
            'Confirmation is required for the items found at the Client’s premises and the items left on site before finalizing the Order.',
          track_employees_mobile:
            'GPS permission is required to record location during Orders and trips between them, useful for traceability and validations.',
          photos_required_mobile: 'Uploading photos of the completed work is required before closing the Order.'
        },
        tracking_level_mobile: {
          hard: 'Hard',
          medium: 'Medium',
          low: 'Low',
          none: 'None'
        }
      }
    },
    news: {
      banner:
        'Select your notification preferences: subscribe to topics of interest to stay up to date with new features, enhancements and fixes.',
      create_new: 'Create New',
      feedback: {
        likes: 'Likes',
        sent: 'Sent',
        viewed: 'Viewed'
      },
      news_preview: 'News preview',
      no_record: 'There is no news to show',
      no_record_subscriptions: 'There are no subscriptions to show',
      service_not_available_subscriptions:
        'At this moment it is not possible to load the subscriptions, please try again later',
      service_not_available_news: 'At this moment it is not possible to load the news, please try again later'
    },
    notification_mail: {
      assigned_installation_order: 'Assigned Installation Order',
      assigned_issue: 'Assigned Issue',
      finalized_issue: 'Finalized Issue',
      closed_issue: 'Closed Issue with comment',
      button: {
        first_image: 'First Image',
        loading_image: 'Loading Image',
        second_image: 'Second Image',
        update_mail_notification: 'Update Mail Notification'
      },
      email_is_not_required: 'In case of leaving it blank, the invoicing firm email will be used',
      first_image: 'First Image',
      image_error_format: 'The image file is invalid, or the image type not allowed. Allowed types: jpeg, jpg, png',
      image_error_weight: 'Image is too big. Max upload file size: 10 MB',
      issued_invoice: 'Issued Invoice',
      mail_notifications_template_title: 'Mail notification templates',
      new_installation_order: 'New Installation Order',
      new_issue: 'New Issue',
      new_payment: 'New Payment',
      provider_offline: 'Provider status changes',
      second_image: 'Second Image',
      timeframe_to_notify_upcoming_changes: 'Timeframe to notify upcoming changes',
      updated_succesful: 'Updated succesful',
      upload_images: 'Upload Images:',
      without_permission: 'You do not have permission'
    },
    notifications: {
      buttons: {
        create: 'Create Notification',
        update: 'Update Notification'
      },
      filter: {
        clients: {
          can_filter_clients_by: 'Can filter Clients by',
          clients_with_invoice: 'With pending invoices',
          clients_without_invoice: 'Without pending invoices',
          filter_by: 'Filter by client or zone',
          only_clients_with_email: 'Only Clients with email',
          only_clients_with_mobile_phone: 'Only Clients with mobile phone'
        },
        contracts: {
          filter_by: 'Filter by client, IP, plan or zone'
        }
      },
      kinds: {
        mail: '[Mail]',
        sms: '[SMS]',
        web: 'Web notification'
      },

      modal_title: {
        mail: 'Mail Notification',
        sms: 'SMS Notification',
        web: 'Web notification'
      },
      select_a_client: 'Must select at least 1 client',
      select_a_contract: 'At least one contract has to be selected',
      select_a_unit: 'Select a unit',
      sms_length_legend: 'SMS length may vary if you use different substitutions, but should not exceed 160 characters',
      tooltips: {
        show: 'Show'
      }
    },
    notification_sms: {
      button: {
        update_sms_notification: 'Update SMS Notification'
      },
      cannot_send_more_until_pay: 'SMS disabled. Either you"re on trial or your subscription is unpaid',
      characters_count: 'Character count: ',
      considerations_text:
        'SMS length may vary if you use different substitutions, but should not exceed {{max_length}} characters. The substitutions enclosed between {{}} will not be counted on body length',
      considerations_title: 'Considerations:',
      contract_alerted: 'Contract alerted',
      contract_disabled: 'Contract disabled',
      issued_invoice: 'Issued Invoice',
      notification_switches_title: 'SMS notification templates',
      phone_number_blank: 'Phone number must be present to test the SMS',
      substitutions_allowed_title: 'The allowed substitutions are:',
      successfully_tested: 'Successfully tested',
      successfully_updated: 'Successfully updated',
      tooltip: {
        first_due_date: 'First due date',
        second_due_date: 'Second due date'
      },
      without_permission: 'You do not have permission'
    },
    payments: {
      client_reference: 'Reference',
      create_new_payment: 'Create new payment',
      import_payments_count_one: '{{count}} payment will be created. Are you sure?',
      import_payments_count_other: '{{count}} payments will be created. Are you sure?',
      import_payments_from: 'Import payments from {{pg}}',
      payment_amount: 'Amount',
      payment_transaction_id: 'ID',
      form: {
        amount_to_pay: 'Amount to pay',
        change: 'Change',
        client_hint: 'Search and select the invoices to pay.',
        client_input_placeholder: "Search by client's name, id or custom id",
        client_input_search_message: 'Type 1 character to search',
        create_payment: 'Create payment',
        current_account_credit: 'Current account credit',
        dont_print_receipt: 'Do not print receipt',
        unexpected_error_paying_invoice_contact_support: 'Unexpected error paying invoice. Contact support',
        error_getting_client_account_info: 'Error getting client account information',
        error_getting_exchange_information: 'Error getting currency converter information',
        error_getting_client_invoices: 'Error getting client invoices',
        no_pending_invoices_to_show: 'The client has no pending invoices to pay.',
        pay_with_current_account_credit: 'Pay with current account credit',
        payment_details_hint: 'Complete with the following data to make payment:',
        payment_details: 'Payment details',
        save_change_in_account: 'Save change in current account',
        searching_invoices: 'We are looking for results. Please wait a moment',
        total_owed: 'Total owed',
        total_to_pay: 'Total to pay'
      },
      importer: {
        import_kind: 'Import kind',
        no_pg_create_here:
          'There are no {{gateway}} payment gateways created. To create one, <anchor>click here</anchor>.',
        must_select_an_import_kind: 'You must select an import kind',
        must_select_a_payment_gateway: 'You must select a payment gateway',
        must_select_one_file: 'You must select one file',
        invalid_file_type: 'Unsupported file type. Only .csv and .xlsx files are allowed'
      },
      new_payment: 'New Payment'
    },
    payment_promises: {
      create: 'Create payment promise',
      searcher: {
        basic_placeholder: 'You can search by: Creator name, Client name.'
      },
      without_permission: 'You do not have permission'
    },
    payment_gateway: {
      create_new_payment_gateway: 'Create new payment gateway'
    },
    payment_promise: {
      created_succesful: 'Payment promise created',
      current: 'Current',
      custom_no_option_message: 'You can search by: Name',
      deleted_succesful: 'Payment promise deleted',
      expired: 'Expired',
      kind: {
        manual: 'Manual',
        api: 'API',
        siro: 'SIRO'
      },
      operation_id: 'Operation ID',
      payment_promise_title: 'New Payment Promise',
      searcher: {
        basic_placeholder: 'You can search by: Creator name, Client name.'
      }
    },
    payment_receipts: {
      pagination_info: '{{paginationFilterTotal}} receipts filtered of {{paginationTotalCount}} in total',
      errors: {
        attachment: {
          not_loaded: 'Failed to load attachment file.'
        }
      },
      state: {
        pending: 'Pending'
      }
    },
    pdf: {
      aliquot: 'IVA Aliquot',
      amount_to_pay_in_payment_gateways: 'Amount to pay in payment gateways',
      argentina: {
        cobro_digital: {
          code_legend: 'Business: Cobro Digital. ID PagoMisCuentas/Link',
          barcode_legend: 'Rapipago, Pagofacil, Banco Bica, ProvinciaNet, Cobro Express, Ripsa, Pronto Pago, Multipago'
        },
        cuenta_digital: {
          code_legend: 'Link Payments code',
          barcode_legend:
            'Rapipago, Pagofacil, Bapro, CobroExpress, ProvinciaNet, Ripsa, Formo Pagos, Pagolisto, Pronto Pago, PampaPagos, ChubutPagos, Cooperativa Obrera'
        },
        siro: {
          code_legend: 'Empresa: Banco Roela SIRO. Código de Pago Electrónico LinkPagos/PagoMisCuentas',
          barcode_legend:
            'Rapipago, PagoFacil, ChubutPagos, Pronto Pago, Santa Cruz Servicios, Munipagos, Santa Fe Servicios, Cobro Express, PampaPagos, Formopagos, Corrientes servicios, ProvinciaNet, San Juan Servicios, Bancor'
        }
      },
      client_address: 'Client address',
      client_data: 'Client Data',
      client_id: 'Client ID',
      client_name: 'Client name',
      client_name_or_invoicing_firm: 'Client Name / Invoicing Firm',
      client_observations: "Client's observations",
      client_signature: "Client's signature",
      colombia: {
        credit_note: 'Nota de Crédito electrónica',
        invoice: 'Factura de venta electrónica',
        first_due_date: 'Timely payment date',
        second_due_date: 'Limit payment date',
        service_cutoff_date: 'Service cutoff date',
        cutoff_date: 'Cutoff date'
      },
      combo_pay: {
        link: 'ComboPay payment link'
      },
      connection_data: 'Connection data',
      contract_id: 'Contract ID',
      discount_rate: '% Discount',
      errors: { deleted_contract: 'Contract has been deleted' },
      equipment: 'Equipment',
      first_due_date: '1º Due',
      gateway_cable_modem: 'Gateway (Cable Modem)',
      ip_cable_modem: 'IP (Cable Modem)',
      mac_address_cable_modem: 'Mac address (Cable Modem)',
      mercado_pago: {
        link: 'Link MercadoPago. Click here'
      },
      payment_method: {
        mexico: {
          single_payment: 'PUE - Pago en una sola exhibición',
          deferred_or_installments_payment: 'PPD - Pago en parcialidades o diferido'
        }
      },
      payment_way: {
        mexico: {
          cash: '01 - Efectivo',
          nominal_check: '02 - Cheque nominativo',
          electronic_transfer: '03 - Transferencia electrónica de fondos',
          credit_card: '04 - Tarjeta de crédito',
          debit_card: '28 - Tarjeta de débito',
          to_define: '99 - Por definir'
        },
        ecuador: {
          without_financial_system: '01 - Without financial system',
          debt_compensation: '15 - Debt compensation',
          debit_card: '16 - Debit card',
          electronic_money: '17 - Electronic money',
          prepaid_card: '18 - Prepaid card',
          credit_card: '19 - Credit card',
          others_with_financial_system: '20 - Others with financial system',
          title_endorsement: '21 - Title endorsement'
        }
      },
      payu: {
        efecty: 'EFECTY Code',
        link: 'Order Link. Click here'
      },
      print_date: 'Print Date',
      quantity: 'QTY',
      second_due_date: '2º Due',
      subtotal_with_iva: 'Subtotal w/IVA',
      tax_ieps: 'IEPS 3%',
      tax_iva_12: 'IVA 12%',
      tax_iva_15: 'IVA 15%',
      tax_iva_16: 'IVA 16%',
      tax_ice_15: 'ICE 15%',
      technician_observations: "Technician's observations",
      technician_signature: "Technician's signature",
      total_owed_at_today: 'Debt up to',
      unit_code: 'Unit',
      username: 'Username'
    },
    pdf_viewer: {
      error: 'Failed to load PDF file',
      no_data: 'No PDF file specified.',
      page_number: 'Page {{numberPage}} of {{totalPage}}'
    },
    ping: 'Ping',
    plan: {
      time_and_burst_enabled: 'Burst | Time Control',
      indicators: {
        burst_enabled: 'Burst enabled',
        burst_disabled: 'Burst disabled',
        time_enabled: 'Time control enabled',
        time_disabled: 'Time control disabled'
      },
      speed_changes: 'Speed change',
      time_control_subtitle: 'Time control from <1> {{time_from}} </1> to <1> {{time_to}}} </1>',
      time_control_times: 'Time control will be applied on the following day: ',
      remove_taxes_message: 'From {{bold}} the following changes will be made:',
      remove_taxes_date: '<0>June 1, 2023</0>',
      remove_taxes_message_item_1:
        'The {{bold}}, which is set in the Plan is removed. From June 1 onwards in case of charging installation the selected tax will be used for each client.',
      remove_taxes_message_item_2:
        'The {{bold}}, which is configured in the Invoicing Profile, is removed. From June 1 onwards in case of charging this surcharge the tax selected in each customer will be used.',
      remove_taxes_installation_tax: '<0>installation tax</0>',
      remove_taxes_recharge_tax: '<0>connection charge tax</0>',
      burst_duration: 'Burst duration',
      burst_duration_down: 'Duration download burst (Seconds)',
      burst_duration_up: 'Duration of up burst (Seconds)',
      button: {
        submit_create: 'Create new Plan',
        submit_update: 'Update'
      },
      degraded_percent: 'Percentage of total plan bandwidth for a contract that has downgraded status',
      invoicing_plan_attributes: {
        installation_price: {
          gross_amount:
            'Service installation fee, can only be used when manually generating the first invoice. <0>IMPORTANT:</0> The value is the final price, so it includes any type of tax in the amount.',
          net_amount:
            'Service installation fee, can only be used when manually generating the first invoice. <0>IMPORTANT:</0> The value is net price.'
        },
        price: {
          gross_amount: '<0>IMPORTANT:</0> The value is the final price, so it includes any type of tax in the amount.',
          net_amount: '<0>IMPORTANT:</0> The value is net price.'
        }
      },
      long_download_max: 'Size at which an HTTP/HTTPS download is classified as P2P traffic',
      long_upload_max: 'Size at which an HTTP/HTTPS payload is classified as P2P traffic',
      propagate_frequency_to_contracts:
        'If you have contracts with custom frequencies, those frequencies will be replaced checking this option. This change will be effective on the next invoicing period.',
      propagate_price_to_contracts:
        'If you have contracts with custom prices, those prices will be replaced checking this option. This change will be effective on the next invoicing period.',
      public_description: 'Visible to clients from the mobile app',
      searcher: {
        advanced_placeholder: 'You can search by: Name',
        basic_placeholder: 'You can search by: Name, Price'
      },
      time_control: 'Time control',
      time_control_header_title: 'Time <1></1> control',
      time_from: 'Format: HH:MM:SS example: 11:15:00 o 22:10:00',
      time_to: 'Format: HH:MM:SS example: 11:15:00 o 22:10:00',
      simple_queue_with_cake_message_notice:
        'Using the strategy <1>Simple queue with cake</1> can significantly increase CPU usage. It is recommended to apply it with a limited number of contracts to maintain good performance.'
    },
    portal_configuration: {
      all: 'All this fields will be used on the Clients Portal section and you can customize them to improve your clients experience.',
      audits_warning:
        'Changes made in the client portal are displayed, as well as those made in the mobile notifications and SMS notifications settings.',
      button: {
        delete: 'Delete',
        update: 'Update'
      },
      change_plan_mobile_setting: 'Change plan',
      company_isotype_hint: 'max dimension {{max}}',
      create_issue_mobile_setting: 'Create Issue',
      create_payment_promise_mobile_setting: 'Create Payment Promise',
      description: 'Will be displayed below the name of your ISP (Be considerate of text size for mobile devices).',
      general_form_title: 'General data',
      graph: 'Enable contract graphics',
      hints: {
        change_plan_mobile_setting: 'Allow clients to request change from the app.',
        create_issue_mobile_setting: 'Allow clients to create tickets from the app.',
        create_payment_promise_mobile_setting: 'Allow clients to create payment promises from the app.',
        wifi_mobile_setting: 'Allow Clients to view the password and request a password change from the app.'
      },
      mobile_settings_title: 'Mobile app',
      placeholder: {
        email: 'Contact email to provide support to clients.',
        mobile_phone: 'Contact number to provide support to clients.',
        name: 'Your ISP name on the Clients Portal section.',
        phone: 'Contact number to provide support to clients.',
        subdomain: 'Your subdomain name for your Clients Portal',
        telegram_phone: 'Telegram user for customer support.',
        whatsapp_phone: 'Contact number to provide support to clients.'
      },
      portal_form_title: 'Client portal',
      portal_logo_hint: 'Max. dimension {{max}}',
      tooltip: {
        click: 'click here'
      },
      welcome: 'Enable Clients Portal',
      wifi_mobile_setting: 'Wifi'
    },
    ppp_profile: {
      cannot_exec_command: 'Can not exec command',
      mikrotik_not_linked: 'MikroTik not linked',
      ppp_profiles_title: 'New PPP Profile',
      ppp_profiles_title_edit: 'Edit PPP Profile',
      searcher: {
        basic_placeholder: 'You can search by: Name, Server, ID, IP Address.'
      },
      'select-ppp_profiles_plan_id-container': 'you can only choose this option if switch is activated.',
      show_quantity_records: 'Displaying profiles {{beginRecords}} - {{endRecords}} of {{total}} in total',
      show_total_records: 'Displaying {{total}} profiles',
      use_rate_limit_off:
        'OFF: Plan-dependent profile, bandwidth changes ({{up}} / {{down}}) made to the plan will affect the profile.',
      use_rate_limit_on:
        'ON: Profile independent of a plan, it is necessary to define widths ({{up}} / {{down}}) of bands on the profile itself.',
      use_rate_limit_title: 'Customize profile',
      define_rate_limit_title: 'Define bandwidth'
    },
    react_quill: {
      editor: {
        align: 'Align',
        background_color: 'Background color',
        bold: 'Bold',
        code_block: 'Code block',
        code_view: 'Code view',
        color: 'Color',
        font_family: 'Font Family',
        font_size: 'Font Size',
        highlight: 'Highlight',
        headings: {
          normal: 'Normal',
          subtitle: 'Subtitle',
          title: 'Title'
        },
        indent: 'Indent',
        insert_link: 'Insert link',
        italic: 'Italic',
        ordered_list: 'Ordered list',
        outdent: 'Outdent',
        picture: 'Picture',
        quote: 'Quote',
        redo: 'Redo',
        remove_styles: 'Remove style',
        size: 'Size',
        styles: 'Styles',
        start_typing_here: 'Start typing here...',
        substitutions: 'Substitutions',
        substitutions_tooltip: 'On click the key will be added to the body',
        underline: 'Underline',
        undo: 'Undo',
        unordered_list: 'Unordered list'
      },
      susbtitutions: {
        amount: 'Amount',
        client_avatar: 'Client avatar',
        client_full_address: 'Client full address',
        client_link_mobile_login: 'Client link mobile login',
        client_mobile_phone: 'Client mobile phone',
        client_name: 'Client name',
        company_logo: 'Company logo',
        contract_full_address: 'Contract full address',
        contract_ip: 'Contract IP',
        first_image: 'First image',
        installation_order_client_name: 'Client Name',
        installation_order_number: 'Installation Order number',
        installation_order_plan_name: 'Plan name',
        invoice_balance: 'Balance',
        invoice_first_due_date: 'First due date',
        invoice_issued_at: 'Issue date',
        invoice_second_due_date: 'Second due date',
        issue_number: 'Number',
        payment_amount_currency: 'Currency',
        payment_created_at: 'Create Date',
        payment_transaction_kind: 'Payment kind',
        pending_invoices: 'Pending invoices',
        plan_name: 'Plan name',
        portal_link: 'Portal link',
        second_image: 'Second image',
        issue_closed_comment: 'Closed Comment'
      }
    },
    recurring_item: {
      count_of_items: 'Invoiced periods',
      every_period: 'Include on every period',
      lapse: {
        every_period: 'Every period'
      },
      infinite: 'Infinite',
      remaining_items: 'Remaining periods',
      summary: 'Summary'
    },
    sale_desk: {
      lead: {
        click_here_to_go_to_client: 'Click here to go to client',
        client_not_generated: 'Client not generated',
        convert_to_client: 'Convert into Client',
        enter_international_phone_number: 'Enter the number in international format',
        format_international: '+[country code][area code][mobile code][number]',
        generated_client: 'Generated client',
        show_lead_detail: 'Show lead detail',
        zone: 'Zone'
      },
      prospect: {
        availabel_connection_points: 'Available connection point(s)',
        connection_point: 'Connection point',
        convert_to_contract: 'Convert into Contract',
        converted: 'Converted',
        generated_contract: 'Generated contract',
        last_ticket_tags: 'Last ticket tags',
        lost: 'Lost',
        pending: 'Pending',
        pending_ticket: 'Pending ticket',
        search_by_leads_name: 'Search by lead name',
        unexpected_error_getting_prospect: 'Unexpected error getting prospect',
        zone: 'Zone'
      },
      ticket: {
        add_tag: 'Add tag',
        assigned_employee_is_from_another_zone: 'The assigned employee belongs to a different zone',
        attachments: 'Attachments',
        attachments_uploaded_successfully: 'Attachments uploaded successfully',
        change_ticket_state: 'Change ticket state',
        change_ticket_tags: 'Change Ticket tags',
        comments_attachments: 'Comments & Attachments',
        create_ticket_with_this_client: 'Create ticket with this client',
        create_ticket_with_this_lead: 'Create ticket with this lead',
        error_fetching_contact_information: 'Error fetching contact information',
        lead_has_no_prospects: 'Lead has no Prospects',
        must_select_a_lead: 'Must select a Lead',
        must_select_a_plan_before_discount: 'Must select a plan before selecting a discount',
        new: {
          summary: 'Summary',
          create_ticket: 'Create Ticket',
          create_ticket_with_installation: 'Create Ticket + Installation',
          create_ticket_with_feasibility: 'Create Ticket + Feasibility',
          packs_card: {
            title: 'DGO Packs',
            placeholder_search: 'Search for DGO pack...'
          },
          discount_card: {
            placeholder_search: 'Search for discount...'
          },
          recurring_item_card: {
            placeholder_search: 'Search for recurring item...'
          }
        },
        new_ticket_state: 'New ticket state',
        no_attachments_to_preview: 'There are no attachments to preview',
        remove_employee: 'Remove employee',
        remove_tag: 'Remove tag',
        schedule_date: 'Schedule date',
        searcher: {
          basic_placeholder: 'You can search by: Lead name'
        },
        show: {
          click_here_to_try_again: 'Click here to try again',
          error_fetching_orders: 'An error occurred while fetching orders',
          error_fetching_comments: 'An error occurred while fetching comments',
          error_fetching_images: 'An error occurred while fetching images'
        },
        upload_attachments_dropzone: 'Drag and drop the files you want to upload or click to select',
        zone: 'Zone'
      },
      tickets: {
        pending: 'Pending',
        pending_order: 'Order in progress',
        success: 'Converted',
        failure: 'Lost'
      }
    },
    seal: {
      code: {
        unit: {
          create_unit_seal: 'Enter a code and press enter'
        }
      },
      only_coordinates_can_be_converted: 'Only coordinates can be coverted to DMS format',
      search_by_nap_name: 'Search by NAP name'
    },
    sent_sms: {
      cannot_send_more_until_pay: 'SMS disabled. Either you"re on trial or your subscription is unpaid.',
      category: {
        contract_alerted: 'Contract alerted',
        contract_disabled: 'Contract disabled',
        issued_invoice: 'Issued invoice',
        manual: 'Manual'
      },
      clickatell_errors: {
        account_is_not_active: 'The account is not active.',
        empty_message_content: 'Message content is empty.',
        integration_is_not_active: 'Your integration is not active. Try to publish your integration first.',
        invalid_destination_address: 'The destination number you are attempting to send to is invalid',
        invalid_or_missing_integration_api_key:
          'The integration API key is either incorrect or has not been included in the API call.',
        maximum_message_parts_exceeded: 'Maximum message parts exceeded.',
        not_enough_money: 'Not enough money',
        too_long_input_phone: 'The phone number is too long',
        too_short_input_phone: 'The phone number is too short',
        us_numbers_limitation: 'US numbers are limited by the CTIA.'
      },
      is_load: 'Sent SMS not found',
      searcher: {
        paid: 'charged',
        to_pay: 'to be charged'
      },
      state: {
        cancelled: 'Cancelled',
        discarded: 'Discarded',
        error: 'Error',
        processed: 'Processed',
        scheduled: 'Queued',
        sent: 'Sent',
        unreachable: 'Unreachable'
      },
      test_sms: 'Test SMS',
      title_badge: 'Monthly',
      title_category: 'SMS categories',
      title_price: 'Estimated price for the next invoice',
      title_sent_sms: 'Sent SMSes'
    },
    sidenav: {
      advanced_configuration: 'Advanced configuration',
      authorized_not_linked_onts: 'Authorized ONUs without contract',
      automigrator: 'Automigrator',
      bmu_versions: 'BMU versions',
      changelogs: 'Changelogs',
      changes_history: 'Recent changes',
      cloud_summary: 'Summary',
      configuration: 'Configuration',
      dashboard: 'Dashboard',
      drafts: 'Drafts',
      inventory: 'Inventory',
      issued: 'Issued',
      kind_feedback: 'Kinds of feedback',
      manuals: 'Manuals',
      optic_fiber: 'Optic fiber',
      orders: 'Orders',
      portal_configuration: 'Clients portal',
      referrals: 'Referrals',
      schedule: 'Schedule',
      stripe_account: 'Invoicing data',
      terms_and_conditions: 'Terms and Conditions',
      wispro_admin: 'Wispro Admin',
      olt_server_interfaces: 'Networks'
    },
    smtp_configuration: {
      send_test_email: 'Send test email',
      send_test_invalid_email: 'Please provide a valid email address.',
      send_test_invalid_response: 'Request failed with status {{status}}. Please try again.',
      send_test_unable_to_send: 'Unable to send test email',
      send_test_email_sent: 'Email sent',
      send_test_success_sent: 'A test email has been sent to ${email}. Please check your inbox.',
      update_smtp_message: 'SMTP Configuration updated: {{message}}',
      smtp_message: 'SMTP Configuration: {{message}}',
      authentication: {
        cram_md5: 'MD5(cram_md5)',
        login: 'Session(login)',
        plain: 'Plain(plain)'
      },
      button: {
        send: 'Send test email',
        submitCreate: 'Create SMTP configuration',
        submitUpdate: 'Update SMTP configuration'
      },
      switch_enable: 'Enabled',
      switch_tls: 'Auto TLS',
      title: 'SMTP configuration to send emails with your own account'
    },
    tv_services: {
      directv_go: {
        header_title_discount: 'Discount Calculation',
        header_title_revenue: 'Revenue Calculation',
        header_unit_total_amount: 'Total excluding TAX',
        header_percentage_discount: 'Discount %',
        header_total_discount: 'Total Discount',
        proportional_cal_title: 'Calculation for Proportional Amounts',
        date_from: 'From',
        date_to: 'To',
        activate_plans: 'Activate Plans',
        active_plans: 'Active Plans',
        basic_plans: 'Basic Plans',
        cancel_subscription: 'Cancel Subscription',
        errors: {
          provider_not_found: 'Service Provider not found'
        },
        configure_directv_go: {
          configure: 'Configure',
          configuring: 'Configuring',
          request_credentials: 'Request credentials',
          subtitle: 'Configure the service with the credentials provided by DirectvGo',
          title: 'Configure DirectvGo'
        },
        confirm_subscription_form: {
          title: 'Are you sure?',
          subtitle_create: 'A new subscription will be created with the following data:',
          subtitle_update: 'The subscription will be updated with the following data:'
        },
        inactive_plans: 'Inactive Plans',
        info_card: {
          subtitle: 'Here you will be able manage Directv Go settings. For mor information <0>click here</0>',
          title: 'DirectvGo Configuration'
        },
        service_will_be_active_next_month: 'Service will be activated next month',
        service_will_be_cancelled_on: 'Service will be canceled on {{date}}',
        service_will_be_cancelled_end_of_month: 'Service will be canceled at the end of the month',
        reactivate_subscription: 'Reactivate Subscription',
        no_packs_message_action: 'Configure Plans',
        no_packs_message_subtitle: 'They can be configured in the Directv Go configuration page',
        no_packs_message_title: 'There are no configured packs',
        pack_info: 'Pack info',
        pack_kind: {
          basic: 'Basic',
          premium: 'Premium'
        },
        total_to_dgo: 'Total to DGO',
        subscription_state_tooltips: {
          to_inactive: 'The subscription will be inactivated at the end of the month'
        },
        aditional_plans: 'Aditinal Plans',
        resume_service: 'Resume Service',
        view_conciliations: 'View conciliations',
        view_invoicing_summary: 'View invoicing summary',
        name_and_lastname_subscription: 'Subscription first and last name',
        subscription_email: 'Subscription email',
        creation_date_acc: 'Date account created',
        date_of_discharge_date: 'Date of service discharge',
        cant_download_transactions: "Unable to download current month's transactions"
      }
    },
    zone: {
      created_succesful: 'Zone created',
      deleted_succesful: 'Zona deleted',
      is_load: 'Zones not found',
      searcher: {
        basic_placeholder: 'You can Search By: Name'
      },
      updated_succesful: 'Zone updated',
      zones_title: 'New Zone',
      zones_title_edit: 'Edit Zone'
    },
    olt: {
      firmware: {
        homologation_states: {
          unknown: 'Unknown firmware',
          unsupported: 'Unsupported firmware',
          supported: 'Supported firmware',
          indeterminate: 'Indeterminate'
        },
        modal: {
          title: 'Firmware Homologation Test'
        },
        tooltip: {
          title: 'Firmware Status',
          status: 'Status',
          model: 'Model',
          version: 'Version',
          release_date: 'Release Date',
          error_message: 'Unable to fetch firmware from OLT'
        },
        homologation: {
          categories: {
            basic_olt_info: 'Basic OLT Information',
            basic_olt_actions: 'Basic OLT Actions',
            authorization: 'Authorization',
            onu_actions: 'ONU Actions',
            onu_info: 'ONU Information'
          },
          tests: {
            basic_info: 'Basic Information',
            capabilities: 'Capabilities',
            onu_info: {
              show_ont_authorization_info: 'ONU Authorization Information',
              show_ont_capability_info: 'ONU Capabilities Information',
              show_ont_info: 'ONU Information',
              show_ont_optical_info: 'ONU Optical Information',
              show_ont_ports_info: 'ONU Ports Information',
              show_ont_version_info: 'ONU Version Information',
              show_ont_wan_info: 'ONU WAN Information'
            },
            show_ont_authorization_info: 'ONU Authorization Information',
            show_ont_capability_info: 'ONU Capabilities Information',
            show_ont_info: 'ONU Information',
            show_ont_optical_info: 'ONU Optical Information',
            show_ont_ports_info: 'ONU Ports Information',
            show_ont_version_info: 'ONU Version Information',
            show_ont_wan_info: 'ONU WAN Information',
            test_activate: 'Activate',
            test_alarms: 'Alarms',
            test_authorization_basic: 'Basic Authorization',
            test_authorization_bridge: 'Bridge Authorization',
            test_authorization_dhcp: 'DHCP Authorization',
            test_authorization_pppoe: 'PPPoE Authorization',
            test_authorization_static: 'Static Authorization',
            test_authorized_onus: 'Authorized ONUs',
            test_create_vlan: 'Create VLAN',
            test_deactivate: 'Deactivate',
            test_disable_catv: 'Disable CATV',
            test_enable_catv: 'Enable CATV',
            test_factory_reset: 'Factory Reset',
            test_mac_address_table: 'MAC Address Table',
            test_reboot: 'Reboot',
            test_signals: 'Signals',
            test_tr069: 'TR-069',
            test_traffic_control: 'Traffic Control',
            test_unauthorized_onus: 'Unauthorized ONUs',
            test_uplink_interfaces: 'Uplink Interfaces'
          },
          modal: {
            error_title: 'Error executing test',
            error_default_message: 'Could not complete the homologation test. Please try again later.',
            instruction: 'Run a test to verify the firmware homologation status.',
            result_title: 'Test Result',
            detailed_results: 'Detailed Results',
            no_data_title: 'Unknown firmware',
            passed: 'passed',
            run_test: 'Run Test',
            test_running_title: 'Test in process...',
            test_running_subtitle: 'Wait while the firmware is homologated'
          }
        }
      },
      autodiscover_onts: 'Autodiscover ONUs',
      available_plans: 'Available plans',
      available_plans_hint: 'Available plans for contracts connected to this OLT',
      olt_should_be_linked: 'OLT Should be linked',
      how_to_interpret_it: '¿How to interpret it?',
      no_default_plan: 'No plan',
      one_default_plan: '1 plan',
      default_plans_count: '{{count}} plans',
      reset_to_default_value: 'Reset to default value ({{message}})',
      statistics: 'Statistics',
      tooltip_message_info_critical_interfaces: 'Critical ports with ONUs linked to Contracts',
      tooltip_message_info_interfaces: 'Pors with ONUs linked to Contracts',
      tooltip_message_info_naps_capacity_total: 'Total capacity',
      tooltip_message_info_naps_capacity_total_full_message:
        'Total number of NAPs slots, including those in use and those free.',
      tooltip_message_info_naps_free_slots: 'NAPs Free slots',
      tooltip_message_info_naps_free_slots_full_message: 'Total number of free NAPs slots',
      tooltip_message_info_naps_onts_linked: 'ONUs linked to NAPs',
      tooltip_message_info_naps_onts_linked_full_message: 'Total number of ONUs linked to NAPs',
      tooltip_message_info_onts_auth_with_contracts: 'ONUs Linked with contracts',
      tooltip_message_info_olts_auth_with_contracts: 'OLT Linked with contracts',
      tooltip_message_info_onts_auth_without_contracts: 'ONUs linked without contracts',
      tooltip_message_info_onts_auth_totals: 'Total authorized ONUs',
      tooltip_message_info_onts_auth_with_contracts_full_message:
        'Number of ONUs that are authorized and linked to any contract.',
      tooltip_message_info_onts_auth_without_contracts_full_message:
        'Number of available ONUs that are authorized to bind to some contract',
      tooltip_message_info_onts_auth_totals_full_message:
        'Total ONUs, both those authorized with contracts and those authorized without contracts.',

      tooltip_message_info_onts_connected: 'ONU Connected with contracts',
      tooltip_message_info_onts_connected_full_message: 'Number of ONUs with contracts online.',
      tooltip_message_info_onts_noConnected: 'Connected ONUs without contracts',
      tooltip_message_info_onts_noConnected_full_message:
        'Number of ONUs that are operational on the OLT but have not been linked to a contract in Wispro.',
      tooltip_message_info_onts_connectedTotal: 'Total ONUs Connected',
      tooltip_message_info_onts_connectedTotal_full_message:
        'Sum of all operational ONUs in the OLT, this includes those that have been linked to a contract and those that have not yet been linked.',

      tooltip_message_info_onts_linked_offline: 'ONUs offline with contract',
      tooltip_message_info_onts_linked_offline_full_message:
        'Total number of ONUs with contracts that are currently offline.',
      tooltip_message_info_onts_linked: 'ONUs linked with contract',
      tooltip_message_info_onts_linked_full_message: 'Total number of ONUs with contracts.',
      tooltip_message_info_onts_ok_signal: 'ONU with optimal signals',
      tooltip_message_info_onts_ok_signal_full_message:
        'Number of ONUs with optimal signals. These are working correctly',

      tooltip_message_info_onts_warning_signal: 'ONUs with warning signals',
      tooltip_message_info_onts_warning_signal_full_message:
        'Number of ONUs with signals in warning state, these exceeded the optimal power threshold',

      tooltip_message_info_onts_critical_signal: 'ONUs with critical signals',
      tooltip_message_info_onts_critical_signal_full_message:
        'Number of ONUs that signals in a Critical state these ONUs are about to exceed critical power thresholds',

      tooltip_message_info_onts_total_signals: 'Total ONUs',
      tooltip_message_info_onts_total_signals_full_message:
        'Total ONUs, connected, authorized and linked with contracts.',

      tooltip_title_critical_nap_alarm: 'NAPs capacity almost full',
      tooltip_explanation_critical_nap_alarm: 'NAPs capacity almost full',
      tooltip_title_critical_not_linked_alarm: 'ONUs authorized without contract',
      tooltip_explanation_critical_not_linked_alarm: 'ONUs authorized without contract',
      tooltip_title_critical_alarms: "Today's critical and major alarms",
      tooltip_explanation_critical_alarms: 'Critical or major alarms',
      tooltip_title_critical_interfaces: 'Critical ports',
      tooltip_explanation_critical_interfaces_reason1: 'Has at least 1 ONU with critical signal',
      tooltip_explanation_critical_interfaces_reason2: 'Has more than 80% of the ONUs with warning signal',
      tooltip_explanation_critical_interfaces_reason3: 'Has some critical or major alarm',
      update_alarms_info_at: 'Last check performed',
      update_authorized_info_at: 'Authorized OLTs info update in:',
      update_unauthorized_info_at: 'Unauthorized OLTs info update in',
      rx_power_critical_lower: 'Power critical lower',
      rx_power_warning_lower: 'Power warning lower',
      rx_power_warning_upper: 'Power warning upper',
      rx_power_critical_upper: 'Power critical upper',
      free: 'Not Linked',
      rx_power_threshold: 'Power alert',
      adapter_error:
        'A communication error occurred with the OLT, please try again. If the problem persists, contact support',
      apply_changes: 'Apply Changes',
      apply_changes_error: 'An error occurred when applying changes.',
      apply_changes_status: 'Apply changes status',
      apply_changes_succed: 'Pending changes had been sent to the router',
      applying_changes: 'Applying changes',
      auth_info: 'Auth Info',
      auth_ont: 'Authorize ONU',
      auth_ont_more_info_available: 'There is more information available',
      auth_ont_get_more_info: 'Click here to request it',
      authorized_onts: 'Authorized ONUs',
      backup: {
        download_backup_error: 'An error ocurred while downloading the backup. Please try again later',
        fetch_backups_error: 'An error ocurred while fetching the backups. Please try again later',
        generate_backup: 'Generate Backup',
        generate_backup_error: 'An error ocurred while generating the backups. Please try again later',
        generate_backup_success: 'Backup generated. You can find it in the top of the list',
        no_data: 'No backups available'
      },
      basic_info: 'Basic Info',
      bridge: 'Bridge',
      cannot_get_traffic_profiles:
        'Cant get traffic profiles. Try again later, if the problem persists contact support.',
      cant_get_optical_info_from_physicial_olt: 'Cant get optical info from physical OLT',
      capa2_info: 'Layer 2 Info',
      catv_config_not_supported: 'ONU does not support CATV configuration',
      catv_control_disabled_text: 'Disabled contracts will keep having CATV service.',
      catv_control_enabled_text: 'Disabled contracts will not have CATV service.',
      catv_control_label: 'CATV Control',
      catv_info: 'CATV Info',
      catv_ports_info: 'CATV Ports Info',
      check_service_wait: 'Check service in progress, please wait.',
      autodiscover_onts_wait: 'Autodiscover ONUs in progress, please wait.',
      choose_an_option: 'Choose an option',
      click_here_to_refresh_list: 'Click here to refresh the list',
      configuration_error: 'There was an error in the configuration. Contact support',
      contract_placeholder: 'You can search by: Client name, IP address, Plan name',
      contract_searcher_placeholder: 'Client name, IP address, Plan',
      couldnt_get_models_for_brands: 'Could not get models for the following brands',
      created_at: 'Created at',
      credentials: 'Credentials',
      current_wan_config: 'Current WAN configuration',
      dashboard: {
        authorized_onts: 'Authorized',
        critical_alarms: 'Critical or Major alarms',
        critical_interfaces: 'Critical interfaces',
        error_querying_olt: 'Error querying OLT',
        interfaces_no_records: 'There are no interfaces to show',
        linked_olts: 'Linked OLTs',
        linked_olts_no_records: 'There are no linked OLTs to show',
        linked_status: 'Linked status',
        not_authorized: 'Not authorized',
        olts_queried: 'OLTs queried',
        querying_olt: 'Querying OLT',
        retry_olts_with_errors: 'Retry OLTs with errors',
        see_ports: 'See ports',
        see_alarms: 'See alarms',
        select_olt_to_show_info: 'Select an OLT to show more information',
        signal_status: 'Signal status',
        successfull_olt_query: 'Successfull OLT query',
        title: 'ONUs detail',
        title_hint: 'The data update depends on the response time of each OLT',
        update_alarms_info_at: 'Alarm check performed on',
        update_authorized_info_at: 'Authorized ONUs check performed on',
        update_unauthorized_info_at: 'Unauthorized ONUs check performed on',
        duration_update_authorized_info: 'Authorized ONUs time check',
        duration_update_unauthorized_info: 'Unauthorized ONUs time check',
        duration_update_alarms_info: 'Alarm time check'
      },
      delete_downstream_gem_traffic_not_supported: 'Bandwidth control is not supported by the OLT',
      delete_upstream_gem_traffic_not_supported: 'Bandwidth control is not supported by the OLT',
      dhcp: 'DHCP',
      downstream_gem_traffic_not_supported: 'Bandwidth control is not supported by the OLT',
      downstream_traffic_control: 'Downstream bandwidth control',
      due_license_detail:
        'Your subscription is outdated, please verify your suscription and your default payment method',
      due_license_error: 'Due subscription',
      error_apply_changes: 'Something went wrong: {{errors}}',
      exceded_max_outbound_speedlimit_entry:
        'The maximum possible number of service ports with downstream bandwidth control has been reached; only upstream control was applied. Contact with support to check if it is possible to update the OLT firmware to fix this problem',
      export_authorized_not_linked_onts: {
        error_toastr: {
          unauthorized: 'You are not allowed to perform this action',
          only_one_pending_export_allowed: 'There is one export pending.\nYou will recive an email with the results',
          olt_not_linked: 'OLT must be linked to perform the export',
          unable_to_schedule_export: 'Error while scheduling the export',
          default_error: 'Unable to export ONUs.\nTry again later or verify the OLT'
        },
        tooltip: 'Export authorized not linked ONUs',
        success_toastr: 'You will recive an email with the results'
      },
      failed_to_get_ont_optical_info: 'ONU Offline: Failed to get ONU optical info',
      general_error: 'Something went wrong, please contact support.',
      general_info: 'General Info',
      import_error: 'Something went wrong when importing your configuration. Please contact support.',
      invalid_ont_interface:
        'The ONU was modified outside of Wispro. You must rewrite the ONU configuration to be able to apply changes from Wispro.',
      ip_mode_hint:
        'When using Router({{ip_mode}}) mode, the type of WAN connection is determined by the contract configuration.',
      is_ont_missing: 'Is your ONU missing?',
      last_acked_pending_sync_does_not_match: 'Last BMU PendingSync does not match with our records',
      last_synchronization: 'Last synchronization',
      last_unsuccessfully_applied_bmu_pending_sync: 'Last unsuccessfully applied bmu pending sync',
      link: 'Link',
      link_error: 'Something went wrong: {{errors}}',
      link_olt: 'The link could take a few minutes, will try to import all the information from the OLT.',
      link_olt_success: 'Linked to OLT successfully',
      link_olt_vsol:
        'In order to work correctly, it\'s necessary to disable the "autolearn" functionality in the OLT. For more information, please contact support.',
      link_ont: 'Link ONU',
      link_ont_advertise:
        'When linking the ONU to a contract, the current settings will be overwritten with the Wispro settings.',
      linked: 'Linked',
      linked_with: 'Linked with',
      linking_olt: 'Linking OLT,please wait.',
      loading_status: 'Loading...',
      msg_time_out: 'Time for wait response expired, try later',
      never: 'Never',
      no_more_numbers: 'No more numbers',
      new_olt_adv: {
        catv_control_disabled: '[Disabled]',
        catv_control_disabled_text: 'Disabled contracts will keep having CATV service.',
        catv_control_enabled: '[Enabled]',
        catv_control_enabled_text: 'Disabled contracts will not have CATV service.',
        catv_control_label: 'CATV Control'
      },
      no_options: 'No results found',
      no_related_information_to_show: 'No related information to show',
      no_wan_config: 'No WAN configurations to show',
      not_linked: 'not linked',
      not_supported_wan_config: 'ONU does not support WAN configuration from OLT',
      number_ont_already_use: 'ONU ID already in use',
      offline: 'Offline',
      olt_summary: 'OLT Summary',
      online: 'Online',
      onu_auth_mode_must_be_in_sn: 'ONU auth mode must be in SN',
      ont_authorized_but_failed_to_save:
        'The ONU was authorized, but there was an error saving the configuration to the OLT',
      ont_doesnt_support_wan_configuration: 'ONU does not support WAN configuration',
      ont_info: 'ONU Info',
      ont_not_exist: 'ONU doesnt exist',
      ont_not_exist_in_physicial_olt: 'ONU doesnt exist in physical OLT',
      ont_not_online: 'ONU is not online',
      ont_provision: 'ONU Provision',
      ont_rate_info: 'ONU-RATE (downstream traffic control)',
      ont_state_info: 'States history',
      ont_autolinked: 'ONUs autolinked',
      onu_in_another_frame_or_board_or_port: 'ONU is in another frame or board or port',
      onu_info: 'ONU Info',
      onu_is_offline: 'ONU is offline',
      onu_offline: 'ONU is offline',
      ont: {
        auth_onts_with_contracts: 'Authorized <1>WITH</1> Contracts',
        auth_onts_without_contracts: 'Authorized <1>WITH</1> Contracts',
        board: 'Board',
        filter_onts_by: 'Filter ONUs by',
        frame: 'Frame',
        interface: 'Interface',
        full_interface: 'Interface F/B/P:N',
        mac_address: 'MAC Address',
        port: 'Port',
        serial: 'Serial Number',
        unauth_onts: '<0>NOT</0> Authorized'
      },
      password: 'Pass',
      pending_changes: 'Pending changes',
      pending_rules: 'Pending Rules',
      pending_rules_keys: {
        autosave_time: 'Daily autosave configuration',
        plan: 'Plan',
        service_port: 'Service Port',
        traffic_control: 'Traffic control',
        traffic_table_inbound: 'Traffic table inbound',
        traffic_table_outbound: 'Traffic table outbound',
        unauthorize_onu: 'Unauthorize onu',
        unknown: 'Unknown',
        update_onu: 'Update onu'
      },
      pppoe: 'PPPoE',
      profiles_info: 'Profiles Info',
      reboot_ont: 'The ONU will restart and will remain without navigation for a few minutes, Do you want to continue?',
      reconfig_ont:
        'Rewriting the configuration will unauthorize the ONU and reauthorize and reconfigure it with all the information defined in the contract.',
      reconfig_wan: 'The WAN configuration will be rewritten, Do you want to continue?',
      factory_reset_ont:
        'This action will delete all user settings, including Wi-Fi name and password, port forwarding, VLANs, etc.<br/> Once complete, the ONU will be restored to its original state and will remain disconnected until the WAN is manually reconfigured. Do you want to continue?',
      resync_ont: 'The ONU will be resynchronized, Do you want to continue?',
      registration_info: 'Registration Info',
      rx_power_critical: 'Critical rx power',
      rx_power_warning: 'Warning rx power',
      rx_power_optimal: 'Optimal rx power',
      rx_power_not_configured: 'Not configured',
      searcher: {
        basic_placeholder: 'You can Search By: Name'
      },
      sending: 'Sending...',
      serial_not_found: 'The ONU serial number does not exist in the OLT',
      serial_number_no_exist: 'Serial number does not exist.',
      search_by_host_address: 'Search by host address',
      search_by_port_number: 'Search by port number',
      service_port_config: 'Service Port Config',
      show_ont_capability_info: 'Capability Info',
      show_ont_info: 'Basic Info',
      show_ont_configuration_info: 'ONU configuration Info',
      show_ont_optical_node_info: 'Optical Node Info',
      show_ont_optical_down_info: 'Optical Down Info',
      show_ont_optical_info: 'Optical Info',
      show_ont_optical_reference_info: 'Optical Reference Info',
      show_ont_optical_up_info: 'Optical Up Info',
      show_ont_port_info: 'Ports Info',
      show_ont_secundary_info: 'Secundary Info',
      show_ont_version_info: 'Version Info',
      snmp: 'SNMP',
      static: 'Static',
      status: 'Status',
      refresh_alarms: 'Refresh',
      synchronization: 'Synchronization',
      tabs: {
        apply_changes_status: 'Apply changes status'
      },
      the_ont_can_not_support: 'ONU does not support WAN configuration',
      there_is_no_wan_configuration_available: 'There is no WAN configuration available',
      timeout_error:
        'Time for wait response expired, try later. First at all check if show as connected before apply changes.',
      tooltips: {
        apply_changes: 'Apply changes',
        applying_changes: 'Applying changes',
        catv_control_disabled: 'CATV control disabled',
        catv_control_enabled: 'CATV control enabled',
        changes_to_apply_count: 'Changes to apply',
        delete_disabled: 'OLT cannot be deleted if it has linked contracts',
        link: 'Link',
        olt_has_pending_configuration: 'The contract is not associated with a ONU, it requires authorization.',
        olt_not_linked: 'The contract is associated with a unlinked OLT, requires linking the OLT',
        olt_provisioning_wan_disabled: 'WAN provisioning disabled',
        olt_provisioning_wan_enabled: 'WAN provisioning enabled',
        reboot_ont: 'Reboot ONU',
        show: 'Show',
        show_onu_actions: 'Show ONU actions',
        show_onu_info: 'Show ONU Info',
        ont_unsync: 'ONU unsynchronized',
        traffic_control_disabled: 'Traffic control disabled',
        traffic_control_enabled: 'Traffic control enabled',
        uplink_interfaces: 'Uplink Interfaces',
        with_gps_point: 'With Geolocation',
        without_gps_point: 'Without Geolocation'
      },
      traffic_control_enabled_hint: 'Disabling bandwidth control will not prioritize or limit customer traffic.',
      try_again_if_persist_contact_with_support: 'Try again later, if the problem persists contact support.',
      try_to_reboot_ont_manually: 'Try to reboot the ONU manually so that the WAN configuration take effect',
      unauth: 'This action implies that you will lose navigation on the equipment, Do you want to continue?',
      unauth_not_linked: 'The ONU will be deauthorized only on the selected PON port. Do you want to continue?',
      unexpected_error_getting_data: 'Unexpected error getting data',
      unlink_ont: 'The ONU will be unlinked from the associated contract. No changes will be made in the OLT.',
      uplink_interfaces: {
        admin_status: 'Admin',
        native_vlan: 'Native VLAN',
        speed: 'Speed',
        tagged_vlans: 'Tagged VLANs',
        untagged_vlans: 'Untagged VLANs',
        uplink_interfaces_sync: 'Refresh Uplink Interfaces'
      },
      update_onu_ont: 'Edit ONU',
      updated_at: 'Updated at',
      upstream_gem_traffic_not_supported: 'Bandwidth control is not supported by the OLT',
      upstream_traffic_control: 'Upstream bandwidth control',
      var_no_resource: 'It is not possible to obtain information about CATV',
      version_info: 'Version Info',
      vlan_no_options: 'No vlan created on the OLT',
      vlans_info: 'VLANs Info',
      wan_config_not_supported: 'ONU does not support WAN configuration from OLT',
      write_to_memory: 'Save configuration'
    },
    vat_condition: {
      billing_regime: 'Billing Regime',
      billing_regime_juridical: 'Billing Regime (Business)',
      billing_regime_person: 'Billing Regime (Person)',
      common_regime: 'Common Regime',
      common_regime_juridical: 'Common Regime (Business)',
      common_regime_person: 'Common Regime (Person)',
      exempt: 'Exempt',
      fantasy: 'Fantasy',
      final_consumer: 'Final consumer',
      registered_vat_payer: 'Registered vat payer',
      self_employed_taxpayer: 'Self employed taxpayer',
      simplified_regime: 'Simplified Regime',
      general_regime: 'General Regime of Legal Persons Law',
      legal_entities_with_non_profit_purpose: 'Legal Entities With Non Profit Purpose',
      wages_and_salaries_and_income_assimilated_to_salaries: 'Wages And Salaries And Income Assimilated To Salaries',
      lease: 'Lease',
      property_disposal_or_acquisition_regime: 'Property Disposal Or Acquisition Regime',
      other_income: 'Other Income',
      residents_abroad_without_permanent_establishment_in_mexico:
        'Residents Abroad Without Permanent Establishment In Mexico',
      dividend_income: 'Dividend Income',
      individuals_with_business_and_professional_activities: 'Individuals With Business And Professional Activities',
      interest_income: 'Interest Income',
      income_regime_for_obtaining_prizes: 'Income Regime For Obtaining Prizes',
      no_tax_obligations: 'No Tax Obligations',
      production_cooperative_societies_that_choose_to_defer_their_income:
        'Production Cooperative Societies That Choose To Defer Their Income',
      tax_incorporation: 'Tax Incorporation',
      agricultural_livestock_forestry_and_fishing_activities: 'Agricultural Livestock Forestry And Fishing Activities',
      optional_for_groups_of_companies: 'Optional For Groups Of Companies',
      coordinated: 'Coordinated',
      regime_of_business_activities_with_income_through_technological_platforms:
        'Regime Of Business Activities With Income Through Technological Platforms',
      simplified_trust_regime: 'Simplified Trust Regime'
    }
  }
};
